'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var coreHttp = _interopDefault(require('@azure/core-http'));
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var tsregistrar = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e();
  }(commonjsGlobal, function () {
    return function (t) {
      function e(n) {
        if (r[n]) return r[n].exports;
        var i = r[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
      }
      var r = {};
      return e.m = t, e.c = r, e.i = function (t) {
        return t;
      }, e.d = function (t, r, n) {
        e.o(t, r) || Object.defineProperty(t, r, {
          configurable: !1,
          enumerable: !0,
          get: n
        });
      }, e.n = function (t) {
        var r = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(r, "a", r), r;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "", e(e.s = 1);
    }([function (t, e, r) {
      function n(t, e) {
        var r,
          n = new Promise(function (e, n) {
            fetch(t).then(function (t) {
              clearTimeout(r), e(t);
            }).catch(function (t) {
              clearTimeout(r), n(t);
            });
          });
        if (0 !== e) {
          var i = new Promise(function (n, i) {
            r = setTimeout(i, e, new Error("Fetch for '" + t.url + "' timed out"));
          });
          return Promise.race([n, i]);
        }
        return n;
      }
      function i(t) {
        try {
          return JSON.stringify(t);
        } catch (e) {
          return "Unable to serialize object of type " + typeof t;
        }
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.fetchWithTimeout = n, e.toJson = i;
      var o = function () {
        function t() {
          this.start = Date.now();
        }
        return Object.defineProperty(t.prototype, "duration", {
          get: function () {
            return Date.now() - this.start;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "startTime", {
          get: function () {
            return this.start;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.reset = function () {
          this.start = Date.now();
        }, t;
      }();
      e.Timespan = o;
    }, function (t, e, r) {
      function n(t, e, r) {
        return new l(t, e, r);
      }
      var i = this && this.__extends || function () {
          var t = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
          };
          return function (e, r) {
            function n() {
              this.constructor = e;
            }
            t(e, r), e.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
          };
        }(),
        o = this && this.__awaiter || function (t, e, r, n) {
          return new (r || (r = Promise))(function (i, o) {
            function s(t) {
              try {
                c(n.next(t));
              } catch (t) {
                o(t);
              }
            }
            function a(t) {
              try {
                c(n.throw(t));
              } catch (t) {
                o(t);
              }
            }
            function c(t) {
              t.done ? i(t.value) : new r(function (e) {
                e(t.value);
              }).then(s, a);
            }
            c((n = n.apply(t, e || [])).next());
          });
        },
        s = this && this.__generator || function (t, e) {
          function r(t) {
            return function (e) {
              return n([t, e]);
            };
          }
          function n(r) {
            if (i) throw new TypeError("Generator is already executing.");
            for (; c;) try {
              if (i = 1, o && (s = 2 & r[0] ? o.return : r[0] ? o.throw || ((s = o.return) && s.call(o), 0) : o.next) && !(s = s.call(o, r[1])).done) return s;
              switch (o = 0, s && (r = [2 & r[0], s.value]), r[0]) {
                case 0:
                case 1:
                  s = r;
                  break;
                case 4:
                  return c.label++, {
                    value: r[1],
                    done: !1
                  };
                case 5:
                  c.label++, o = r[1], r = [0];
                  continue;
                case 7:
                  r = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (s = c.trys, !(s = s.length > 0 && s[s.length - 1]) && (6 === r[0] || 2 === r[0])) {
                    c = 0;
                    continue;
                  }
                  if (3 === r[0] && (!s || r[1] > s[0] && r[1] < s[3])) {
                    c.label = r[1];
                    break;
                  }
                  if (6 === r[0] && c.label < s[1]) {
                    c.label = s[1], s = r;
                    break;
                  }
                  if (s && c.label < s[2]) {
                    c.label = s[2], c.ops.push(r);
                    break;
                  }
                  s[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              r = e.call(t, c);
            } catch (t) {
              r = [6, t], o = 0;
            } finally {
              i = s = 0;
            }
            if (5 & r[0]) throw r[1];
            return {
              value: r[0] ? r[1] : void 0,
              done: !0
            };
          }
          var i,
            o,
            s,
            a,
            c = {
              label: 0,
              sent: function () {
                if (1 & s[0]) throw s[1];
                return s[1];
              },
              trys: [],
              ops: []
            };
          return a = {
            next: r(0),
            throw: r(1),
            return: r(2)
          }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
            return this;
          }), a;
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var a = r(0),
        c = function (t) {
          function e(e) {
            var r = t.call(this, e) || this;
            return r.name = "CancelationError", r;
          }
          return i(e, t), e;
        }(Error),
        u = function () {
          function t(e, r, n) {
            this.logger = e, this.maxBackoffInMs = r, this.initialDelay = n, this.backoffCount = 0, this.id = ++t.idCounter;
          }
          return t.prototype.delay = function (t) {
            var e = this;
            if (void 0 !== this.timerHandle) throw new Error("Retry sequence logical failure");
            if (-1 === this.backoffCount) return new Promise(function (t, e) {
              e(new c("Cancelled"));
            });
            var r = this.calculateNextBackoffMs();
            return this.backoffCount++, this.logger.info("[RegistrarClient] Backing off " + t + " for " + r + " milliseconds with ID " + this.id), new Promise(function (n, i) {
              e.cancelFunc = i, e.timerHandle = setTimeout(function () {
                e.logger.info("[RegistrarClient] Back off for " + t + " with ID " + e.id + " complete"), e.timerHandle = void 0, n();
              }, r);
            });
          }, t.prototype.cancel = function () {
            void 0 !== this.timerHandle && (this.logger.debug("Resetting back off"), clearTimeout(this.timerHandle), void 0 !== this.cancelFunc && this.cancelFunc(new c("Cancelled"))), this.backoffCount = -1;
          }, t.prototype.calculateNextBackoffMs = function () {
            var t = 1 + .4 * (Math.random() - .5),
              e = this.initialDelay * Math.pow(2, this.backoffCount) * t;
            return e = Math.round(e), Math.min(this.maxBackoffInMs, e);
          }, t.idCounter = 0, t;
        }(),
        l = function () {
          function t(t, e, r) {
            this.logger = t, this.skypeTokenProvider = e, this.options = r, this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN = 15, this.DEFAULT_MAX_BACKOFF_TIME_IN_MS = 3e5, this.backoffs = {}, this.maxBackOffTime = this.options.maxRetryDelayMs > 0 ? this.options.maxRetryDelayMs : this.DEFAULT_MAX_BACKOFF_TIME_IN_MS, this.maxRetriesForGetToken = void 0 === r.maxRetriesForGetToken || null === r.maxRetriesForGetToken ? this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN : r.maxRetriesForGetToken;
          }
          return t.prototype.setTelemetryLogger = function (t) {
            this.eventLogger = t;
          }, t.prototype.register = function (t, e) {
            return o(this, void 0, void 0, function () {
              return s(this, function (r) {
                switch (r.label) {
                  case 0:
                    return [4, this.performRegistration(t, e, "pr_set_registration")];
                  case 1:
                    return r.sent(), this.cachedRegistrationParams = [t, e], [2];
                }
              });
            });
          }, t.prototype.unregister = function () {
            return o(this, void 0, void 0, function () {
              var t;
              return s(this, function (e) {
                switch (e.label) {
                  case 0:
                    return this.logger.info("[RegistrarClient] sending unregister request"), t = new Request(this.options.registrarUrl + "/" + this.options.registrationId, {
                      method: "DELETE",
                      mode: "cors",
                      headers: new Headers({
                        accept: "application/json, text/javascript"
                      })
                    }), [4, this.callRegistrar(t, "pr_delete_registration")];
                  case 1:
                    return e.sent(), [2];
                }
              });
            });
          }, t.prototype.cancelPendingRequests = function () {
            var t = this;
            Object.keys(this.backoffs).forEach(function (e) {
              t.backoffs[e].cancel();
            }), this.backoffs = {};
          }, t.prototype.resendRegistration = function () {
            return o(this, void 0, void 0, function () {
              return s(this, function (t) {
                switch (t.label) {
                  case 0:
                    if (!this.cachedRegistrationParams) throw new Error("Re-registration failed because there is no registration parameters cached");
                    return [4, this.performRegistration(this.cachedRegistrationParams[0], this.cachedRegistrationParams[1], "pr_resend_registration")];
                  case 1:
                    return t.sent(), [2];
                }
              });
            });
          }, t.prototype.performRegistration = function (t, e, r) {
            return o(this, void 0, void 0, function () {
              var n, i;
              return s(this, function (o) {
                switch (o.label) {
                  case 0:
                    return this.logger.info("[RegistrarClient] Sending register request"), n = {
                      clientDescription: t,
                      registrationId: this.options.registrationId,
                      nodeId: "",
                      transports: e
                    }, i = new Request(this.options.registrarUrl, {
                      method: "POST",
                      mode: "cors",
                      headers: new Headers({
                        "content-type": "application/json",
                        accept: "application/json, text/javascript"
                      }),
                      body: a.toJson(n)
                    }), [4, this.callRegistrar(i, r)];
                  case 1:
                    return o.sent(), [2];
                }
              });
            });
          }, t.prototype.startBackoff = function () {
            var t = new u(this.logger, this.maxBackOffTime, this.options.initialRetryDelayMs);
            return this.backoffs[t.id] = t, t;
          }, t.prototype.stopBackoff = function (t) {
            t.cancel(), delete this.backoffs[t.id];
          }, t.prototype.getSkypeToken = function () {
            return o(this, void 0, void 0, function () {
              var t, e, r, n, i, o, a;
              return s(this, function (s) {
                switch (s.label) {
                  case 0:
                    t = this.startBackoff(), e = 0, s.label = 1;
                  case 1:
                    return s.trys.push([1, 3,, 8]), this.logger.info("[RegistrarClient] Asking for a new skypetoken"), [4, this.skypeTokenProvider(!0)];
                  case 2:
                    return r = s.sent(), this.stopBackoff(t), [2, r];
                  case 3:
                    n = s.sent(), s.label = 4;
                  case 4:
                    return s.trys.push([4, 6,, 7]), (e++, i = JSON.stringify(n), e > this.maxRetriesForGetToken) ? (o = "[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Error: " + i, this.logger.error(o), this.stopBackoff(t), [2, Promise.reject(o)]) : (this.logger.warn("[RegistrarClient] Retrying for a new skype token. Retry Count: " + e + " Error: " + i), [4, t.delay("Fetching a new skypetoken")]);
                  case 5:
                    return s.sent(), [3, 8];
                  case 6:
                    throw a = s.sent(), this.stopBackoff(t), a;
                  case 7:
                    return [3, 8];
                  case 8:
                    return [3, 1];
                  case 9:
                    return [2];
                }
              });
            });
          }, t.prototype.callRegistrar = function (t, e) {
            return o(this, void 0, void 0, function () {
              var r, n, i, o, c, u, l, f, h, p, d, g, y, k, m, v;
              return s(this, function (s) {
                switch (s.label) {
                  case 0:
                    return r = this.startBackoff(), [4, this.skypeTokenProvider(!1)];
                  case 1:
                    n = s.sent(), this.setSkypeTokenHeader(t, n), i = new a.Timespan(), o = 0, s.label = 2;
                  case 2:
                    c = void 0, s.label = 3;
                  case 3:
                    return s.trys.push([3, 8, 13, 14]), u = t.clone(), [4, a.fetchWithTimeout(u, this.options.requestTimeoutMs)];
                  case 4:
                    return c = s.sent(), 401 !== c.status ? [3, 6] : ++o > this.maxRetriesForGetToken ? (l = "[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Request '" + t.url + "' failed with " + c.status + " " + c.statusText, this.logger.error(l), this.stopBackoff(r), [2, Promise.reject(l)]) : (this.logger.warn("[RegistrarClient] Retry Count " + o + ". Request '" + t.url + "' failed with " + c.status + " " + c.statusText), f = this.setSkypeTokenHeader, h = [t], [4, this.getSkypeToken()]);
                  case 5:
                    return f.apply(this, h.concat([s.sent()])), [3, 20];
                  case 6:
                    if (c.status >= 500 && c.status < 600) throw new Error("Fetch for '" + t.url + "' failed with " + c.status + " " + c.statusText);
                    s.label = 7;
                  case 7:
                    return [3, 14];
                  case 8:
                    p = s.sent(), this.logger.error("[RegistrarClient] Request failed with " + p), s.label = 9;
                  case 9:
                    return s.trys.push([9, 11,, 12]), [4, r.delay("Registrar call retry")];
                  case 10:
                    return s.sent(), [3, 20];
                  case 11:
                    throw d = s.sent(), this.logger.error("[RegistrarClient] Request cancelled"), this.stopBackoff(r), d;
                  case 12:
                    return [3, 14];
                  case 13:
                    return this.sendTelemetryEvent(e, t, c, i), [7];
                  case 14:
                    return this.stopBackoff(r), c.ok ? [2, c] : [3, 15];
                  case 15:
                    g = void 0, s.label = 16;
                  case 16:
                    return s.trys.push([16, 18,, 19]), k = (y = JSON).stringify, [4, c.json()];
                  case 17:
                    return g = k.apply(y, [s.sent()]), [3, 19];
                  case 18:
                    return m = s.sent(), g = "no details", [3, 19];
                  case 19:
                    throw v = "Fetch for '" + t.url + "' failed with " + c.status + " " + c.statusText + " (" + g + ", MS-CV: " + c.headers.get("MS-CV") + ")", this.logger.error("[RegistrarClient] " + v), new Error(v);
                  case 20:
                    return [3, 2];
                  case 21:
                    return [2];
                }
              });
            });
          }, t.prototype.setSkypeTokenHeader = function (t, e) {
            t.headers.set("X-Skypetoken", e);
          }, t.prototype.sendTelemetryEvent = function (t, e, r, n) {
            if (void 0 !== this.eventLogger) {
              var i = {
                name: t,
                properties: {
                  url: {
                    value: e.url
                  },
                  result_code: {
                    value: void 0 !== r ? r.status : 0
                  },
                  begin_timestamp: {
                    value: n.startTime
                  },
                  elapsed: {
                    value: n.duration
                  }
                }
              };
              this.eventLogger.logEvent(i);
            }
          }, t;
        }();
      e.RegistrarClient = l, e.createRegistrarClient = n;
    }]);
  });
});
unwrapExports(tsregistrar);
var tstrouter = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e(tsregistrar);
  }(commonjsGlobal, function (t) {
    return function (t) {
      function e(o) {
        if (n[o]) return n[o].exports;
        var i = n[o] = {
          i: o,
          l: !1,
          exports: {}
        };
        return t[o].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
      }
      var n = {};
      return e.m = t, e.c = n, e.i = function (t) {
        return t;
      }, e.d = function (t, n, o) {
        e.o(t, n) || Object.defineProperty(t, n, {
          configurable: !1,
          enumerable: !0,
          get: o
        });
      }, e.n = function (t) {
        var n = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(n, "a", n), n;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "", e(e.s = 19);
    }([function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = function () {
        function t(t, e) {
          this.name = t, this.logger = e;
        }
        return t.prototype.debug = function (t) {
          this.logger.debug("[" + this.name + "] " + t);
        }, t.prototype.info = function (t) {
          this.logger.info("[" + this.name + "] " + t);
        }, t.prototype.warn = function (t) {
          this.logger.warn("[" + this.name + "] " + t);
        }, t.prototype.error = function (t) {
          this.logger.error("[" + this.name + "] " + t);
        }, t;
      }();
      e.Logger = o;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.constants = {
        TROUTER_INIT: "trouterinit",
        TROUTER_READY_EVENT: "trouterReadyEvent",
        TROUTER_READY_TIMEOUT: "trouterReadyTimeout",
        TROUTER_TOKEN_REQUEST: "trouterTokenRequest",
        TROUTER_TOKEN_GET_SUCCEEDED: "trouterTokenGetSucceeded",
        TROUTER_TOKEN_GET_FAILED: "trouterTokenGetFailed",
        TROUTER_RECONNECTING: "trouterReconnecting",
        RENEWAL: "renewal",
        NEW_CONNECTION: "newConnection",
        ENDPOINT_REGISTRATION_FAILED: "endpointRegistrationFailed"
      }, e.CLIENT_VERSION = "2022.35.01.26", e.HANDLED_MESSAGE_ACK = 200, e.UNHANDLED_MESSAGE_ACK = 404, e.FAILED_MESSAGE_ACK = 500;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      !function (t) {
        t[t.Unknown = 0] = "Unknown", t[t.Active = 1] = "Active", t[t.Inactive = 2] = "Inactive";
      }(e.UserActivityState || (e.UserActivityState = {}));
      var o = function () {
        function t() {}
        return t;
      }();
      e.HttpHeaders = o;
      !function (t) {
        t[t.Unknown = 0] = "Unknown", t[t.Connected = 2] = "Connected", t[t.Disconnected = 3] = "Disconnected", t[t.Switching = 9] = "Switching";
      }(e.TrouterState || (e.TrouterState = {}));
    }, function (t, e, n) {
      function o(t) {
        try {
          return JSON.stringify(t);
        } catch (e) {
          return "Unable to serialize object of type " + typeof t;
        }
      }
      function i(t) {
        var e = Math.round(new Date().getTime() / 1e3);
        return void 0 !== t && t > e ? t - e : 0;
      }
      function r(t) {
        return Math.round(new Date().getTime() / 1e3) + t;
      }
      function s(t, e) {
        return c(this, void 0, void 0, function () {
          var n, o, i;
          return a(this, function (r) {
            return o = new Promise(function (e, o) {
              fetch(t).then(function (t) {
                clearTimeout(n), e(t);
              }).catch(function (t) {
                clearTimeout(n), o(t);
              });
            }), 0 !== e ? (i = new Promise(function (o, i) {
              var r = new URL(t.url),
                s = new Error(t.method + " " + r.origin + r.pathname + " timed out");
              n = setTimeout(i, e, s);
            }), [2, Promise.race([o, i])]) : [2, o];
          });
        });
      }
      var c = this && this.__awaiter || function (t, e, n, o) {
          return new (n || (n = Promise))(function (i, r) {
            function s(t) {
              try {
                a(o.next(t));
              } catch (t) {
                r(t);
              }
            }
            function c(t) {
              try {
                a(o.throw(t));
              } catch (t) {
                r(t);
              }
            }
            function a(t) {
              t.done ? i(t.value) : new n(function (e) {
                e(t.value);
              }).then(s, c);
            }
            a((o = o.apply(t, e || [])).next());
          });
        },
        a = this && this.__generator || function (t, e) {
          function n(t) {
            return function (e) {
              return o([t, e]);
            };
          }
          function o(n) {
            if (i) throw new TypeError("Generator is already executing.");
            for (; a;) try {
              if (i = 1, r && (s = 2 & n[0] ? r.return : n[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, n[1])).done) return s;
              switch (r = 0, s && (n = [2 & n[0], s.value]), n[0]) {
                case 0:
                case 1:
                  s = n;
                  break;
                case 4:
                  return a.label++, {
                    value: n[1],
                    done: !1
                  };
                case 5:
                  a.label++, r = n[1], n = [0];
                  continue;
                case 7:
                  n = a.ops.pop(), a.trys.pop();
                  continue;
                default:
                  if (s = a.trys, !(s = s.length > 0 && s[s.length - 1]) && (6 === n[0] || 2 === n[0])) {
                    a = 0;
                    continue;
                  }
                  if (3 === n[0] && (!s || n[1] > s[0] && n[1] < s[3])) {
                    a.label = n[1];
                    break;
                  }
                  if (6 === n[0] && a.label < s[1]) {
                    a.label = s[1], s = n;
                    break;
                  }
                  if (s && a.label < s[2]) {
                    a.label = s[2], a.ops.push(n);
                    break;
                  }
                  s[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              n = e.call(t, a);
            } catch (t) {
              n = [6, t], r = 0;
            } finally {
              i = s = 0;
            }
            if (5 & n[0]) throw n[1];
            return {
              value: n[0] ? n[1] : void 0,
              done: !0
            };
          }
          var i,
            r,
            s,
            c,
            a = {
              label: 0,
              sent: function () {
                if (1 & s[0]) throw s[1];
                return s[1];
              },
              trys: [],
              ops: []
            };
          return c = {
            next: n(0),
            throw: n(1),
            return: n(2)
          }, "function" == typeof Symbol && (c[Symbol.iterator] = function () {
            return this;
          }), c;
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.toJson = o, e.calculateTtlInSec = i, e.calculateExpireTsInSec = r, e.fetchWithTimeout = s;
      var h = function () {
        function t(t) {
          this.base = void 0 !== t ? t : this.createCorrelationVectorBase(), this.extension = 0;
        }
        return t.extend = function (e) {
          return new t(e);
        }, t.prototype.increase = function () {
          this.extension++;
        }, t.prototype.value = function () {
          return this.base + "." + this.extension;
        }, t.prototype.createCorrelationVectorBase = function () {
          for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0987654321/+", e = "AQgw", n = "", o = 0; o < 21; o++) n += t.charAt(Math.floor(Math.random() * t.length));
          return n += e.charAt(Math.floor(Math.random() * e.length));
        }, t;
      }();
      e.CorrelationVector = h;
      var u = function () {
        function t() {
          this.start = Date.now();
        }
        return Object.defineProperty(t.prototype, "duration", {
          get: function () {
            return Date.now() - this.start;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(t.prototype, "startTime", {
          get: function () {
            return this.start;
          },
          enumerable: !0,
          configurable: !0
        }), t.prototype.reset = function () {
          this.start = Date.now();
        }, t;
      }();
      e.Timespan = u;
    }, function (t, e) {
      var n;
      n = function () {
        return this;
      }();
      try {
        n = n || Function("return this")() || (0, eval)("this");
      } catch (t) {
        "object" == typeof window && (n = window);
      }
      t.exports = n;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(3),
        i = function () {
          function t(t, e, n, o, i, r, s) {
            this.connectionId = t, this.connectedClientId = e, this.domId = n, this.unsecureUrl = o, this.url = i, this.c2cUrlBase = r, this.expirationTsSec = s;
          }
          return t.prototype.getRemainingTtlInSec = function () {
            return o.calculateTtlInSec(this.expirationTsSec);
          }, t;
        }();
      e.ServerState = i;
      !function (t) {
        t[t.Unknown = 0] = "Unknown", t[t.Modified = 1] = "Modified", t[t.Snapshot = 2] = "Snapshot", t[t.Connected = 3] = "Connected";
      }(e.UserActivityEventReason || (e.UserActivityEventReason = {}));
    }, function (t, e, n) {
      var o = this && this.__assign || Object.assign || function (t) {
        for (var e, n = 1, o = arguments.length; n < o; n++) {
          e = arguments[n];
          for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        }
        return t;
      };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i,
        r = n(20),
        s = n(12),
        c = n(3),
        a = n(15),
        h = n(1),
        u = n(16),
        l = n(2),
        p = n(5),
        d = n(0),
        g = n(17),
        f = n(11),
        v = function () {
          function t() {
            this.cv = h.CLIENT_VERSION, this.ua = "", this.hr = "", this.v = "";
          }
          return t;
        }(),
        m = function () {
          function t() {
            this["force new connection"] = !0, this.reconnect = !1, this.query = "", this.ackTimeoutMs = 5e3;
          }
          return t;
        }(),
        y = "MS-CV",
        T = function () {
          function t(t) {
            this.cvCounter = 0;
            var e = JSON.parse(t);
            this.startTS = e.hasOwnProperty("startTS") ? e.startTS : 0, this.url = e.hasOwnProperty("url") ? e.url : "", this.shortUrl = e.hasOwnProperty("shortUrl") ? e.shortUrl : "", this.body = e.hasOwnProperty("body") ? e.body : "", this.headers = e.hasOwnProperty("headers") ? e.headers : {}, this.id = e.hasOwnProperty("id") && "number" == typeof e.id ? e.id : -1, this.method = e.hasOwnProperty("method") ? e.method : "", this.replied = !1, this.timedout = !1, this.timeoutTimerId = 0, this.receivedCv = this.headers[y], this.updateCvHeader();
          }
          return Object.defineProperty(t.prototype, "correlationVector", {
            get: function () {
              return this.receivedCv ? this.receivedCv + "." + this.cvCounter : "";
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.on = function (t, e) {
            "data" === t ? this.dataCallback = e : "end" === t && ("function" == typeof this.dataCallback && this.dataCallback(this.body), e());
          }, t.prototype.incrementCorrelationVector = function () {
            ++this.cvCounter, this.updateCvHeader();
          }, t.prototype.updateCvHeader = function () {
            var t = this.correlationVector;
            t && (this.headers[y] = t);
          }, t;
        }(),
        k = function () {
          function t(t, e, n) {
            this.request = t, this.responseData = e, this.sendResponse = n;
          }
          return t.prototype.writeHead = function (t, e) {
            this.responseData.status = t, this.responseData.headers = e;
          }, t.prototype.write = function (t) {
            this.responseData.body += t;
          }, t.prototype.end = function (t) {
            return t && (this.responseData.body += t), this.sendResponse(this.request, this.responseData);
          }, t;
        }(),
        w = function () {
          function t(t) {
            this.name = t, this.args = {}, this.timeoutTimerId = 0;
          }
          return t;
        }();
      !function (t) {
        t[t.Configuration = 0] = "Configuration", t[t.ServerInitiated = 1] = "ServerInitiated";
      }(i = e.ReconnectReason || (e.ReconnectReason = {}));
      var S = function () {
        function t(t, e, n, o, i) {
          var s = this;
          this.options = e, this.manager = n, this.tokenProvider = o, this.connectionId = "", this.inIncallMode = !1, this.connectionAttempt = 0, this.connectedClientId = "", this.isNavigatorOnline = !0, this.onNavigatorOnlineStatusUpdateBound = this.onNavigatorOnlineStatusUpdate.bind(this), this.c2cUrlBase = "", this.allocationErrorsInRow = 0, this.unauthorizedErrorCount = 0, this.pendingTimers = {}, this.lastDisconnectReason = "", this.UNKNOWN_TRANSPORT = "unknown_transport", this.logger = new d.Logger("Connection", t), this.timeoutOptions = this.options.timeoutOptions, this.tokenBackoff = new u.ExponentialBackoff(this.logger, this.timeoutOptions.maxBackoffMs), this.clientID = Date.now(), "undefined" != typeof window && window.location && (this.domId = window.location.hostname), this.clientInfo = new v(), this.clientInfo.cv = h.CLIENT_VERSION, this.clientInfo.ua = "", this.options && this.options.clientInfo && (this.clientInfo.ua = this.safeString(this.options.clientInfo.ua), this.clientInfo.v = this.safeString(this.options.clientInfo.v)), this.connectionTracker = new a.ConnectionTracker(t, this.clientID, this.clientInfo, function () {
            return s.getServerState();
          }, this.options.endpointId, this.options.clientCorrelationID, this.options.environment), this.applyConnectionTrackerOptions(e);
          var c = this.options.incallModeTimeoutMs > 0;
          if (this.fsm = new g.TrouterFsm(t, this, c), e.registration) {
            var l = {
              registrarUrl: e.registration.registrarUrl,
              registrationId: e.registration.registrationId,
              requestTimeoutMs: e.timeoutOptions.fetchTimeoutMs,
              initialRetryDelayMs: 1e3,
              maxRetryDelayMs: e.timeoutOptions.maxBackoffMs
            };
            this.registrarClient = r.createRegistrarClient(t, this.tokenProvider, l);
          }
          this.userActivityState = i;
        }
        return t.prototype.start = function (t) {
          this.logger.info("Starting"), this.reconnectParams = t, "undefined" != typeof window && window.navigator ? (this.isNavigatorOnline = window.navigator.onLine, window.addEventListener("online", this.onNavigatorOnlineStatusUpdateBound), window.addEventListener("offline", this.onNavigatorOnlineStatusUpdateBound), this.logger.debug("Registered for browser online notifications - current state: " + this.isNavigatorOnline)) : this.isNavigatorOnline = !0, this.fsm.start();
        }, t.prototype.stop = function (t) {
          this.logger.info("Stopping"), "undefined" != typeof window && window.navigator && (window.removeEventListener("online", this.onNavigatorOnlineStatusUpdateBound), window.removeEventListener("offline", this.onNavigatorOnlineStatusUpdateBound)), this.fsm.stop(t), this.connectionTracker.close();
        }, t.prototype.configure = function (t) {
          var e = this.options.trouterUrl !== t.trouterUrl;
          this.options = t, this.applyConnectionTrackerOptions(t), e && (this.logger.info("Configuration changed. Reconnection required."), this.fsm.onReconnectRequired(!1, i.Configuration));
        }, t.prototype.checkConnection = function (t) {
          this.logger.info("checkConnection called with " + t), this.fsm.checkConnection(t), t && this.connectionTracker.sendTelemetry(a.ClientEventName.CheckConnection, {
            disconnectDetected: t
          }, []);
        }, t.prototype.disableRegistrationsAndAutoReconnect = function () {
          this.stopRegisterTimer(), this.resetRegisterBackoff(), this.fsm.disableAutoReconnect();
        }, t.prototype.getServerState = function () {
          return new p.ServerState(this.connectionId, this.connectedClientId, this.domId ? this.domId : "", this.allocateResult ? this.allocateResult.url : "", this.allocateResult ? this.allocateResult.surl : "", this.c2cUrlBase, this.connectionExpireTimestampInSecs);
        }, t.prototype.getToken = function (t, e, n) {
          var o = this;
          void 0 === n && (n = 0), this.logger.info("Getting token " + (e ? "with backoff" : "without backoff"));
          var i = function () {
            o.connectionTracker.trackStart("token"), o.tokenProvider(!t).then(function (t) {
              o.logger.debug("token is received"), o.connectionTracker.trackEnd("token"), o.fsm.onTokenReceived(t);
            }).catch(function (e) {
              var i = c.toJson(e.stack);
              if (o.logger.error("Getting token failed, will retry after timeout. Error: " + i), o.connectionTracker.trackError("token", i), !o.canRetryTokenFetchRequest(n + o.unauthorizedErrorCount)) {
                return o.connectionTracker.trackError("token", "getToken retry limit hit, reached terminal error state"), o.resetTokenBackoff(), void o.fsm.onTerminalError();
              }
              o.getToken(t, !0, n + 1);
            });
          };
          e ? this.tokenBackoff.backoff("getting token", i) : (this.resetTokenBackoff(), i());
        }, t.prototype.startConnectionTimer = function () {
          var t = this;
          this.stopConnectionTimer(), this.logger.debug("Starting connection timeout for " + this.timeoutOptions.connectionTimeoutMs + " ms"), this.connectionTimeoutId = setTimeout(function () {
            t.logger.info("Connection timeout is fired"), t.fsm.onConnectingTimeout();
          }, this.timeoutOptions.connectionTimeoutMs);
        }, t.prototype.stopConnectionTimer = function () {
          this.connectionTimeoutId && (this.logger.debug("Stopping connection timeout"), clearTimeout(this.connectionTimeoutId), this.connectionTimeoutId = void 0);
        }, t.prototype.startPingTimer = function () {
          var t = this;
          "websocket" === this.transportTypeName ? (this.logger.debug("Starting ping timeout for " + this.timeoutOptions.pingTimeoutMs + " ms"), this.pingTimerId = setInterval(function () {
            t.logger.info("Ping interval fired"), t.fsm.onPingInterval();
          }, this.timeoutOptions.pingTimeoutMs)) : this.logger.debug("Not starting ping for transport " + this.transportTypeName);
        }, t.prototype.stopPingTimer = function () {
          this.pingTimerId && (this.logger.debug("Stopping ping timeout"), this.clearPingResponseTimer(), clearInterval(this.pingTimerId), this.pingTimerId = void 0);
        }, t.prototype.shouldSkipRegistration = function () {
          return void 0 === this.options.registration;
        }, t.prototype.hasCustomRegisterTtl = function () {
          return this.options.registration && this.options.registration.registrarTtlSec;
        }, t.prototype.startRegisterTimer = function () {
          var t = this;
          void 0 !== this.registrationTimerId && this.stopRegisterTimer();
          var e = this.getRegistrationTtl(),
            n = e[0],
            o = (e[1], n - 30);
          if (o <= 0) return void this.logger.debug("Not starting registration timer, ttl too low(" + n + " sec)");
          this.logger.debug("Starting registration timeout for " + o + " sec"), this.registrationTimerId = setTimeout(function () {
            t.logger.info("Registration timeout is fired"), t.registrationTimerId = setTimeout(function () {
              t.registrationTimerId = void 0, t.logger.debug("Re-registration did not happen in time"), t.dispatchUnregistered();
            }, 3e4), t.fsm.onRegistrationTimeout();
          }, 1e3 * o);
        }, t.prototype.stopRegisterTimer = function () {
          this.registrationTimerId && (this.logger.debug("Stopping registration timeout"), clearTimeout(this.registrationTimerId), this.registrationTimerId = void 0);
        }, t.prototype.resendRegistration = function () {
          if (!this.registrarClient) throw new Error("Trouter Client not configured to handle registrations");
          return this.registrarClient.resendRegistration();
        }, t.prototype.buildSocketIoUrlParams = function () {
          if (!this.allocateResult) throw new Error("Allocate result is undefined in buildSocketIoUrlParams()");
          for (var t = {}, e = this.allocateResult.connectparams, n = 0, o = Object.keys(e); n < o.length; n++) {
            var i = o[n];
            e.hasOwnProperty(i) && void 0 !== e[i] && (t[i] = e[i]);
          }
          return t.v = "v4", t.tc = encodeURI(c.toJson(this.clientInfo)), t.timeout = this.timeoutOptions.pingTimeoutMs / 1e3, t.auth = "true", this.options.endpointId && (t.epid = this.options.endpointId), this.userActivityState.state !== l.UserActivityState.Unknown && (t.userActivity = encodeURI(c.toJson(this.userActivityState.toEventObject()))), this.appendConnectedClientIds(this.buildQuery(t), !0);
        }, t.prototype.startSocketIo = function () {
          var t = this;
          if (this.logger.info("Starting socket io"), this.connectionTracker.trackStart("connectSocket"), !this.allocateResult) throw new Error("Allocate result is undefined in startSocketIo()");
          var e = this.options.ioOptions || new m();
          if (e["force new connection"] = !0, e.reconnect = !1, e.query = this.buildSocketIoUrlParams(), this.logger.info("connecting to " + this.allocateResult.socketio + "?" + e.query), this.stopSocketIo(), this.socket = (this.options.io || f).connect(this.allocateResult.socketio, e), void 0 === this.socket) throw new Error("Can't create Socket.io object");
          this.socket.on("connecting", function (e) {
            t.onSocketConnecting(e);
          }), this.socket.on("connect", function () {
            t.onSocketConnect();
          }), this.socket.on("connect_failed", function (e) {
            t.onSocketConnectFailed(e);
          }), this.socket.on("disconnect", function (e) {
            t.onSocketDisconnect(e);
          }), this.socket.on("reconnect", function () {
            t.onSocketReconnect();
          }), this.socket.on("reconnect_failed", function (e) {
            t.onSocketReconnectFailed(e);
          }), this.socket.on("reconnecting", function () {
            t.onSocketReconnecting();
          }), this.socket.on("error", function (e) {
            t.onSocketError(e);
          }), this.socket.on("message", function (e) {
            t.onSocketMessage(e);
          }), this.socket.on("trouter.connected", function (e) {
            t.onTrouterConnected(e);
          }), this.socket.on("trouter.reconnect", function (e) {
            t.onTrouterReconnect(e);
          }), this.socket.on("trouter.message_loss", function (e) {
            t.onTrouterMessageLoss(e);
          });
        }, t.prototype.stopSocketIo = function () {
          if (this.socket) {
            this.logger.info("clearing socket.io");
            try {
              for (var t = 0, e = ["connecting", "connect", "connect_failed", "disconnect", "reconnect", "reconnect_failed", "reconnecting", "error", "message", "trouter.connected", "trouter.reconnect", "trouter.message_loss"]; t < e.length; t++) {
                var n = e[t];
                this.socket.removeAllListeners(n);
              }
              this.socket.disconnect(), this.logger.debug("cleared socket"), this.socket = void 0;
            } catch (t) {
              this.logger.error("exception in disconnecting previous socket. Error: " + c.toJson(t.stack));
            }
          }
        }, t.prototype.dispatchConnected = function () {
          this.logger.info("dispatching connected"), this.manager.onConnected(this);
        }, t.prototype.dispatchRegistered = function () {
          this.logger.info("dispatching registered"), this.manager.onRegistered(this);
        }, t.prototype.dispatchUnregistered = function () {
          this.logger.info("dispatching unregistered"), this.manager.onUnregistered(this);
        }, t.prototype.dispatchDownstreamRequest = function (t) {
          var e = this;
          this.logger.info("dispatching downstream request");
          try {
            var n = new k(t, new a.ResponseData(t.id), function (t, n) {
              return e.logger.info("sending response to downstream"), e.sendResponse(t, n);
            });
            this.manager.onDownstreamRequest(this, t, n);
          } catch (t) {
            this.logger.error("exception in socket.on message. Error : " + c.toJson(t.stack));
          }
        }, t.prototype.dispatchReconnecting = function () {
          this.logger.info("dispatching reconnecting"), this.manager.onReconnecting(this);
        }, t.prototype.dispatchReconnectIsRequired = function (t, e) {
          this.logger.info("dispatching reconnect is required by server"), this.manager.onReconnectIsRequired(this, t, e);
        }, t.prototype.dispatchDisconnected = function () {
          this.logger.info("dispatching disconnected"), this.manager.onDisconnected(this);
        }, t.prototype.dispatchTrouterMessageLost = function (t) {
          this.logger.info("dispatching trouter lost message"), this.manager.onTrouterMessageLost(t);
        }, t.prototype.sendProcessedDroppedIndicators = function (t) {
          var e = this;
          try {
            this.logger.info("emitting processed flow tags to the server");
            var n = new w("trouter.processed_message_loss");
            n.args = {
              droppedIndicators: t
            }, this.sendDownstreamEvent(n, function () {
              e.logger.info("emitted processed flow tags to the server");
            });
          } catch (t) {
            var o = c.toJson(t.stack);
            this.logger.error("unable to send processed message loss event. Error: " + o), this.connectionTracker.trackError("trouter.processed_message_loss", o, !1);
          }
        }, t.prototype.sendAllocateRequest = function (t) {
          var e = this;
          this.connectionAttempt++, this.connectionTracker.trackNewConnection();
          var n,
            i = this.options.trouterUrl,
            r = i,
            s = this.reconnectParams;
          s && s.se && parseInt(s.se, 10) <= Date.now() + 36e5 && (this.logger.warn("Dropping expired cached connection parameters: " + new Date(parseInt(s.se, 10))), this.reconnectParams = s = void 0), s && s.serviceUrl !== r && (this.logger.warn("Dropping cached connection parameters for a different environment (" + s.serviceUrl + ", now " + r + ")"), this.reconnectParams = s = void 0), s && s.reconnectUrl && (r = s.reconnectUrl), n = s ? o({}, s, {
            serviceUrl: void 0,
            reconnectUrl: void 0
          }) : null, r = this.appendCorrelationIds(r, !1), r = this.appendEndpointId(r, !1), n && (r += "&" + this.buildQuery(n), n.v || (r += "&v=v4"));
          var a = new Request(r, {
            method: "POST",
            mode: "cors",
            headers: new Headers({
              "X-Skypetoken": t,
              "Content-Type": "text/plain"
            })
          });
          this.logger.info("sendAllocateRequest: POST " + r), this.connectionTracker.trackStart("allocation");
          var h = Date.now(),
            u = -1;
          c.fetchWithTimeout(a, this.timeoutOptions.fetchTimeoutMs).then(function (t) {
            if (u = t.status, !t.ok) throw new Error(t.statusText);
            var n = t.headers.get("content-type");
            if (!n || "application/json" !== n && "application/json;" !== n.substring(0, 17)) throw new Error("Content-type '" + n + "' is unexpected");
            return e.connectionTracker.trackEnd("allocation"), t.json();
          }).then(function (t) {
            e.allocationErrorsInRow = 0, e.unauthorizedErrorCount = 0, e.onAllocationResponse(t, i);
          }).catch(function (t) {
            e.allocationErrorsInRow++;
            var n = t + ", status code " + u;
            if (e.logger.error(e.allocationErrorsInRow + " failed allocation attempt(s) in a row. Error: " + n), e.connectionTracker.trackError("allocation", n), 401 === u && e.unauthorizedErrorCount++, !e.canRetryTokenFetchRequest(e.unauthorizedErrorCount)) {
              return e.connectionTracker.trackError("allocation", "getToken retry limit hit, reached terminal error state"), void e.fsm.onTerminalError();
            }
            if (-1 !== u || e.isNavigatorOnline) {
              if (e.reconnectParams && e.allocationErrorsInRow >= 3) if (u >= 400 && u <= 599) e.logger.warn(e.allocationErrorsInRow + " connection attempts, server-side failure: erasing cached connection parameters"), e.reconnectParams = void 0;else if (e.reconnectParams.reconnectUrl && e.allocationErrorsInRow % 3 == 0) {
                e.logger.warn(e.allocationErrorsInRow + " connection attempts, testing nominal service URL");
                var o = Math.min(e.timeoutOptions.connectionTimeoutMs - (Date.now() - h) - 500, e.timeoutOptions.fetchTimeoutMs);
                return void e.testNominalUrlConnectivity(o).then(function (t) {
                  e.connectionTracker.trackProgress("nomcheck", t ? "ok" : "failed"), t ? (e.logger.warn("Nominal service URL is reachable, erasing cached reconnect URL"), e.reconnectParams && delete e.reconnectParams.reconnectUrl) : e.logger.warn("Nominal service URL is not reachable either, keeping cached reconnect URL"), e.fsm.onAllocationFailed(!1);
                }, function (t) {
                  e.fsm.onAllocationFailed(!1);
                });
              }
            } else e.logger.info("Expected failure, the browser says it is not online at the moment");
            e.fsm.onAllocationFailed(401 === u);
          });
        }, t.prototype.testNominalUrlConnectivity = function (t) {
          var e = this;
          if (t < 1e3) return this.logger.warn("There is no time left to reasonably perform the nominal service URL connectivity check (" + t + " ms), falling back to assuming that the connectivity is fine"), s.Promise.resolve(!0);
          var n;
          try {
            var o = new URL(this.options.trouterUrl);
            o.pathname = "/", o.search = "?" + this.buildQuery({
              check: Date.now(),
              cor_id: encodeURIComponent(this.options.clientCorrelationID),
              epid: encodeURIComponent(this.options.endpointId ? this.options.endpointId : ""),
              tc: encodeURIComponent(c.toJson(this.clientInfo))
            }), n = new Request(o.toString(), {
              method: "GET",
              headers: {
                Accept: "text/plain"
              }
            });
          } catch (t) {
            return this.logger.warn("Nominal service URL connectivity test request could not be created (" + t + "), falling back to assuming that the connectivity is fine"), s.Promise.resolve(!0);
          }
          return c.fetchWithTimeout(n, t).then(function (t) {
            if (200 !== t.status) throw new Error("Not 200 OK: " + t.status + " " + t.statusText);
            return t.text();
          }).then(function (t) {
            if ("Trouter" !== t) throw new Error('Not "Trouter": ' + t.substring(0, 16) + (t.length > 16 ? "..." : ""));
            return !0;
          }).catch(function (t) {
            return e.logger.error("Nominal service URL connectivity test failed: " + t), !1;
          });
        }, t.prototype.sendPingRequest = function () {
          var t = this;
          if (this.socket && void 0 === this.pingResponseTimerId) try {
            this.logger.info("emitting ping event");
            var e = !1;
            this.socket.emit("ping", function () {
              !0 !== e && t.onPingResponse();
            }), this.pingResponseTimerId = setTimeout(function () {
              t.logger.error("Ping response timeout is fired"), e = !0, t.clearPingResponseTimer(), t.fsm.onPingResponseTimeout();
            }, this.timeoutOptions.pongTimeoutMs);
          } catch (t) {
            var n = c.toJson(t.stack);
            this.logger.error("unable to send ping. Error: " + n), this.connectionTracker.trackError("ping", n, !1);
          }
        }, t.prototype.setUserActivityState = function (t) {
          var e = t.state !== this.userActivityState.state;
          this.userActivityState = t, this.fsm.onSetUserActivityState(t, e);
        }, t.prototype.sendUserActivityState = function (t, e) {
          this.userActivityState.state !== l.UserActivityState.Unknown && ("websocket" === this.transportTypeName && e ? t === p.UserActivityEventReason.Connected ? this.sendUserActivityStateMultiple(2) : this.sendUserActivityStateMultiple(1) : "xhr-polling" === this.transportTypeName && t === p.UserActivityEventReason.Modified && this.fsm.forceReconnect("user activity/force reconnect"));
        }, t.prototype.sendRegisterRequest = function () {
          var t = this;
          if (!this.options.registration || !this.registrarClient) throw new Error("Internal error - options.registration is undefined");
          if (!this.allocateResult) throw new Error("Allocate result is undefined in sendRegisterRequest()");
          this.logger.info("sending register request");
          var e = new c.Timespan();
          this.connectionTracker.trackStart("registration");
          var n = this.getRegistrationTtl(),
            o = n[0],
            i = n[1];
          this.registrarClient.register({
            appId: this.options.registration.pnhAppId,
            aesKey: "",
            languageId: "en-US",
            platform: this.options.registration.platform,
            templateKey: this.options.registration.pnhTemplateKey,
            platformUIVersion: this.options.registration.platformUIVersion,
            productContext: this.options.registration.productContext
          }, {
            TROUTER: [{
              context: this.options.registration.context,
              path: this.allocateResult.surl,
              ttl: o
            }]
          }).then(function () {
            t.logger.info("Register request successful"), t.connectionTracker.trackEnd("registration"), t.fsm.onRegistrationSucceed(i), t.connectionTracker.sendTelemetry(a.ClientEventName.Registration, {
              duration: e.duration
            }, []);
          }).catch(function (n) {
            t.logger.error("Register request failed. Error: " + n), t.connectionTracker.trackError("registration", n.message), t.fsm.onRegistrationFailed(!1), t.connectionTracker.sendTelemetry(a.ClientEventName.Registration, {
              duration: e.duration
            }, []);
          });
        }, t.prototype.sendUnregisterRequest = function () {
          var t = this;
          this.logger.info("sending unregister request");
          var e = new c.Timespan();
          if (!this.options.registration || !this.registrarClient) throw new Error("Internal error - options.registration is undefined");
          this.connectionTracker.trackStart("unregistration"), this.registrarClient.unregister().then(function () {
            t.logger.info("Unregister request successful"), t.connectionTracker.trackEnd("unregistration"), t.fsm.onUnregistrationSucceed(), t.connectionTracker.sendTelemetry(a.ClientEventName.Unregistration, {
              duration: e.duration
            }, []);
          }).catch(function (n) {
            t.logger.error("Unregister request failed. Error: " + n), t.connectionTracker.trackError("unregistration", n.message), t.fsm.onUnregistrationFailed(!1), t.connectionTracker.sendTelemetry(a.ClientEventName.Unregistration, {
              duration: e.duration
            }, []);
          });
        }, t.prototype.resetTokenBackoff = function () {
          this.tokenBackoff.reset();
        }, t.prototype.resetRegisterBackoff = function () {
          this.registrarClient && this.registrarClient.cancelPendingRequests();
        }, t.prototype.clearTimers = function () {
          this.logger.debug("Clearing all pending downstream events related timers");
          for (var t = 0, e = Object.keys(this.pendingTimers); t < e.length; t++) {
            var n = e[t];
            this.clearTimer(Number(n));
          }
        }, t.prototype.restartIncallModeTimer = function () {
          var t = this;
          this.clearIncallModeTimerId(), this.logger.debug("Restarting incall mode timer"), this.incallModeTimerId = setTimeout(function () {
            t.logger.info("Call mode timer fired"), t.fsm.onIncallModeTimer();
          }, this.options.incallModeTimeoutMs);
        }, t.prototype.enterIncallMode = function () {
          this.logger.info("Entering incall mode"), this.timeoutOptions = this.options.incallTimeoutOptions, this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs), this.inIncallMode = !0;
        }, t.prototype.exitIncallMode = function () {
          this.logger.info("Exiting incall mode"), this.clearIncallModeTimerId(), this.timeoutOptions = this.options.timeoutOptions, this.tokenBackoff.setMaxBackoffMs(this.timeoutOptions.maxBackoffMs), this.inIncallMode = !1;
        }, t.prototype.isIncallMode = function () {
          return this.inIncallMode;
        }, t.prototype.sendDisconnectTelemetryEvent = function (t) {
          var e = {
            reason: t,
            serverClosed: !this.fsm.isActive()
          };
          this.connectionTracker.trackDisconnected(e), this.connectionTracker.clearConnectedInfo();
        }, t.prototype.onSocketConnecting = function (t) {
          this.logger.info("onSocketConnecting(" + t + ")"), this.transportTypeName = t, this.connectionTracker.trackProgress("connecting", this.transportTypeName), this.fsm.onConnecting();
        }, t.prototype.onSocketConnect = function () {
          this.logger.info("onSocketConnect");
        }, t.prototype.onSocketConnectFailed = function (t) {
          this.logger.error("onSocketConnectFailed"), this.connectionTracker.trackError("connect_failed", t, !0, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT), this.fsm.onConnectingFailed();
        }, t.prototype.onSocketDisconnect = function (t) {
          this.logger.error("onSocketDisconnect, reason: " + t);
          var e = this.connectionTracker.getSessionLength() || 0;
          "dup" === t && "dup" === this.lastDisconnectReason && e < this.options.duplicateDisconnectThresholdMs && (this.logger.warn("Socket was closed by server as Duplicate for the second time in a row after " + e + " ms which is below the threshold of " + this.options.duplicateDisconnectThresholdMs + " ms. Resetting cached connection parameters and making a new allocation."), this.reconnectParams = void 0), this.lastDisconnectReason = t, this.fsm.onSocketDisconnect(t), this.connectionExpireTimestampInSecs = void 0;
        }, t.prototype.onSocketReconnect = function () {
          this.logger.error("onSocketReconnect"), this.fsm.onTrouterConnected();
        }, t.prototype.onSocketReconnectFailed = function (t) {
          this.logger.error("onSocketReconnectFailed with '" + t + "'"), this.fsm.onSocketDisconnect("string" == typeof t ? t : void 0);
        }, t.prototype.onSocketReconnecting = function () {
          this.logger.error("onSocketReconnecting");
        }, t.prototype.onSocketError = function (t) {
          this.logger.error("onSocketError with '" + c.toJson(t) + "'"), this.connectionTracker.trackError("connectSocket", t), this.fsm.onSocketDisconnect("string" == typeof t ? t : void 0);
        }, t.prototype.onSocketMessage = function (t) {
          var e = this;
          this.logger.info("onSocketMessage");
          var n;
          try {
            n = new T(t);
            var o = n.headers && n.headers["X-Microsoft-Skype-Chain-ID"],
              i = o ? " Chain-Id " + o : "";
            this.logger.info("Received request N " + n.id + i + " CV " + n.correlationVector + " to '" + n.url + "'"), n.startTS = Date.now(), n.url && this.urlPath && 0 === n.url.indexOf(this.urlPath) && (n.shortUrl = n.url.substring(this.urlPath.length));
          } catch (t) {
            var r = c.toJson(t.stack);
            return this.logger.error("unable to parse request. Error: " + r), this.connectionTracker.trackRequest(void 0, r), void this.connectionTracker.sendResponseError("unable to parse request, error: " + t);
          }
          n.timeoutTimerId = setTimeout(function () {
            if (!n.replied) {
              e.logger.error("Request " + n.id + " timed out");
              var t = new a.ResponseData(n.id);
              t.status = 504, t.headers = {
                "Trouter-Responder": "ClientLib"
              }, e.sendResponse(n, t), n.timedout = !0;
            }
          }, this.timeoutOptions.requestTimeoutMs);
          try {
            this.connectionTracker.trackRequest(n), this.fsm.onDownstreamRequest(n);
          } catch (t) {
            this.logger.error("exception in socket.on message. Error: " + c.toJson(t.stack)), this.connectionTracker.sendResponseError(t.message, n, void 0);
          }
        }, t.prototype.onTrouterConnected = function (t) {
          if (!this.allocateResult) return void this.logger.error("Invalid internal state - received onTrouterConnected while allocateResult is not set");
          this.logger.info("onTrouterConnected: " + this.allocateResult.url), this.socket && this.socket.socket && this.socket.socket.options && this.socket.socket.options.query && (this.socket.socket.options.query += "&connected=true"), this.urlPath = this.allocateResult.url.replace(/https?:\/\/([A-z0-9\:\$\-\_\.\+\!\*\"\(\)\,]*)\//, "/");
          var e = this.connectedUrl !== this.allocateResult.url;
          this.connectedUrl = this.allocateResult.url, this.connectionExpireTimestampInSecs = c.calculateExpireTsInSec(t.ttl), this.connectionTracker.trackEnd("connectSocket"), this.connectionTracker.trackConnected(e, this.transportTypeName ? this.transportTypeName : this.UNKNOWN_TRANSPORT), this.fsm.onTrouterConnected();
        }, t.prototype.onTrouterReconnect = function (t) {
          var e = t.target;
          this.logger.info("onTrouterReconnect target: " + e), "self" === e ? this.fsm.onReconnectRequired(!0, i.ServerInitiated) : this.fsm.onReconnectRequired(!1, i.ServerInitiated);
        }, t.prototype.onTrouterMessageLoss = function (t) {
          this.logger.info("onTrouterMessageLoss"), this.fsm.onTrouterMessageLost(t.droppedIndicators);
        }, t.prototype.onNavigatorOnlineStatusUpdate = function (t) {
          var e = window.navigator.onLine;
          this.logger.debug("Browser online status update - new state: " + e + ", previously: " + this.isNavigatorOnline), e && !this.isNavigatorOnline ? (this.isNavigatorOnline = !0, this.tokenBackoff.expediteIfPending(), this.connectionTracker.trackProgress("browserNet", "online")) : !e && this.isNavigatorOnline && (this.isNavigatorOnline = !1, this.connectionTracker.trackProgress("browserNet", "offline"));
        }, t.prototype.onAllocationResponse = function (t, e) {
          this.logger.info("Received allocation response " + JSON.stringify(t)), this.allocateResult = t, this.reconnectParams = o({
            serviceUrl: e,
            reconnectUrl: this.allocateResult.socketio + "v4/a"
          }, t.connectparams);
          var n = +t.ttl;
          if (this.connectionExpireTimestampInSecs = c.calculateExpireTsInSec(n), this.connectionId = this.allocateResult.id || "", this.connectedClientId = this.allocateResult.ccid, this.logger.info("connected client id set {connectedClientId:" + this.connectedClientId + "}"), this.c2cUrlBase = t.curlb || "", "" === this.c2cUrlBase) {
            var i = t.surl.indexOf("://");
            i >= 0 && (i = t.surl.indexOf("/", i + 3)) >= 5 && ":3443" === t.surl.substr(i - 5, 5) && (this.c2cUrlBase = t.surl.substr(0, i - 5));
          }
          this.manager.onConnectionParametersUpdated(this.reconnectParams), this.fsm.onAllocationSucceed();
        }, t.prototype.onPingResponse = function () {
          this.logger.info("onPingResponse"), this.connectionTracker.increasePingResponseCount(), this.clearPingResponseTimer(), this.fsm.onPingResponse();
        }, t.prototype.clearPingResponseTimer = function () {
          void 0 !== this.pingResponseTimerId && (clearTimeout(this.pingResponseTimerId), this.pingResponseTimerId = void 0);
        }, t.prototype.buildQuery = function (t) {
          for (var e = [], n = 0, o = Object.keys(t); n < o.length; n++) {
            var i = o[n];
            t.hasOwnProperty(i) && void 0 !== t[i] && e.push(i + "=" + t[i]);
          }
          return e.join("&");
        }, t.prototype.appendConnectedClientIds = function (t, e) {
          var n = "";
          t.indexOf("ccid=") < 0 && (n = "ccid=" + this.connectedClientId + "&"), this.domId && (n += "dom=" + this.domId + "&"), n.length > 0 && (n = n.slice(0, -1));
          var o = e || -1 !== t.indexOf("?") ? "&" : "?";
          return this.appendCorrelationIds(t + o + n, e);
        }, t.prototype.appendEndpointId = function (t, e) {
          var n = e || -1 !== t.indexOf("?") ? "&" : "?";
          return t.indexOf("epid") < 0 && this.options.endpointId ? "" + t + n + "epid=" + this.options.endpointId : t;
        }, t.prototype.appendCorrelationIds = function (t, e) {
          var n = e || -1 !== t.indexOf("?") ? "&" : "?";
          return t.indexOf("cor_id") < 0 ? "" + t + n + "cor_id=" + this.options.clientCorrelationID + "&con_num=" + this.clientID + "_" + this.connectionAttempt : t;
        }, t.prototype.safeString = function (t) {
          return "string" == typeof t ? t : "";
        }, t.prototype.sendResponse = function (t, e) {
          if (t.timedout) return this.logger.error("Request " + t.id + " already timed out"), 1;
          if (t.replied) return this.logger.error("Response for request " + t.id + " already sent"), 2;
          clearTimeout(t.timeoutTimerId), t.timeoutTimerId = 0, t.replied = !0, e.headers = e.headers || {};
          var n = t.correlationVector;
          this.logger.info("Sending response for request N " + t.id + " CV " + n + " with status " + e.status), n && (e.headers[y] = n), t.headers && t.headers["trouter-request"] && !e.headers["trouter-request"] && (e.headers["trouter-request"] = t.headers["trouter-request"]);
          var o = Date.now() - t.startTS;
          if (e.headers["trouter-client"] = c.toJson({
            cd: o
          }), this.logger.debug("response: " + c.toJson(e)), !this.socket) return this.connectionTracker.sendResponseError("no socket", t, e), 4;
          try {
            return this.socket.send(c.toJson(e)), e.sentTS = Date.now(), t.incrementCorrelationVector(), this.connectionTracker.trackResponse(t, o, e), "websocket" === this.transportTypeName && this.sendPingRequest(), 0;
          } catch (n) {
            var i = "unable to send data on response.end. Error: " + c.toJson(n.stack);
            return this.logger.error(i), this.connectionTracker.sendResponseError(i, t, e), 4;
          }
        }, t.prototype.sendUserActivityStateMultiple = function (t) {
          var e = this,
            n = new w("user.activity"),
            o = this.userActivityState.toEventObject();
          n.args = o, this.userActivityState.correlationVector.increase(), this.logger.debug("Sending user activity '" + this.userActivityState.toEventJSON() + "', remaining " + (t - 1));
          var i = !1;
          this.sendDownstreamEvent(n, function () {
            if (!0 !== i && (e.logger.info("User activity state: " + o.state + ", cv: " + o.cv + " accepted"), e.manager.onUserActivityStateAccepted && e.manager.onUserActivityStateAccepted(o.cv), e.clearTimer(n.timeoutTimerId), t > 1)) {
              var r = setTimeout(function () {
                e.clearTimer(r), e.sendUserActivityStateMultiple(t - 1);
              }, e.options.userActivitySecondResendDelayMs);
              e.registerTimer(r, "user.activity/resend");
            }
          }), n.timeoutTimerId = setTimeout(function () {
            e.logger.error("Activity state response timeout is fired"), i = !0, e.fsm.onActivityStateResponseTimeout(), e.clearTimer(n.timeoutTimerId);
          }, this.timeoutOptions.userActivityResponseTimeoutMs), this.registerTimer(n.timeoutTimerId, "user.activity/response");
        }, t.prototype.sendDownstreamEvent = function (t, e) {
          this.logger.info("Sending downstream event " + t.name), this.socket && this.socket.emit(t.name, t.args, e);
        }, t.prototype.registerTimer = function (t, e) {
          this.logger.debug("registering timer " + t + " -> " + e), this.pendingTimers[t] = e;
        }, t.prototype.clearTimer = function (t) {
          var e = this.pendingTimers[t];
          this.logger.debug("clearing timer " + t + " -> " + e), delete this.pendingTimers[t], clearTimeout(t);
        }, t.prototype.getRegistrationTtl = function () {
          var t = c.calculateTtlInSec(this.connectionExpireTimestampInSecs);
          if (this.logger.debug("Current connectionID will expire in " + t + " seconds"), this.options.registration && this.options.registration.registrarTtlSec && t > 0) {
            var e = this.options.registration.registrarTtlSec < t;
            return [Math.min(this.options.registration.registrarTtlSec, t), e];
          }
          return this.options.registration && this.options.registration.registrarTtlSec ? [this.options.registration.registrarTtlSec, !1] : t > 0 ? [t, !1] : [3600, !1];
        }, t.prototype.clearIncallModeTimerId = function () {
          void 0 !== this.incallModeTimerId && (this.logger.debug("Clearing in-call mode timer"), clearTimeout(this.incallModeTimerId), this.incallModeTimerId = void 0);
        }, t.prototype.applyConnectionTrackerOptions = function (t) {
          try {
            t.eventLogger && "function" == typeof t.eventLogger.logEvent ? (this.connectionTracker.mergeSettings(t.telemetrySettings), this.connectionTracker.enable(t.eventLogger)) : this.logger.warn("Trouter client event logging disabled due to invalid configuration.");
          } catch (t) {
            this.logger.warn("Trouter client event logging disabled. Error: " + c.toJson(t.stack)), this.connectionTracker.disable();
          }
        }, t.prototype.canRetryTokenFetchRequest = function (t) {
          var e = this.options.retryLimitOnTokenFetch;
          return null === e || void 0 === e || t < e || (this.logger.warn("Reached limit on maximum number of token fetch request. Current count: " + t + ", retry limit: " + e), !1);
        }, t;
      }();
      e.TrouterConnection = S;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(1),
        i = function () {
          function t(t) {
            this.logger = t, this.messageHandlers = [];
          }
          return t.prototype.register = function (t) {
            if (this.messageHandlers.some(function (e) {
              return e === t;
            })) throw new Error("Registering the same handler twice is not allowed");
            this.messageHandlers.push(t);
          }, t.prototype.clear = function () {
            this.logger.debug("Clearing message handlers"), this.messageHandlers = [];
          }, t.prototype.active = function () {
            return this.messageHandlers.length > 0;
          }, t.prototype.handleMessage = function (t) {
            for (var e = {
                resultCode: o.UNHANDLED_MESSAGE_ACK,
                isHandled: !1
              }, n = 0, i = this.messageHandlers; n < i.length; n++) {
              var r = i[n],
                s = this.safeExecuteHandle(r, t);
              if (void 0 !== s && (void 0 === s.isHandled || s.isHandled)) return void 0 === s.resultCode && (s.resultCode = o.HANDLED_MESSAGE_ACK), s;
            }
            return e;
          }, t.prototype.safeExecuteHandle = function (t, e) {
            try {
              return t.handleMessage(e);
            } catch (t) {
              return void this.logger.warn("A trouter message handler is throwing exceptions. exception: " + t);
            }
          }, t;
        }();
      e.MessageHandlerRegistry = i;
    }, function (t, e, n) {
      function o(t) {
        var e,
          n = this;
        return function (o) {
          return i(n, void 0, void 0, function () {
            return r(this, function (n) {
              return o && (e = void 0), [2, new Promise(function (n, i) {
                t(o).then(function (t) {
                  e = t, n(t);
                }).catch(function (t) {
                  void 0 !== e && e.length > 0 && n(e), i(t);
                });
              })];
            });
          });
        };
      }
      var i = this && this.__awaiter || function (t, e, n, o) {
          return new (n || (n = Promise))(function (i, r) {
            function s(t) {
              try {
                a(o.next(t));
              } catch (t) {
                r(t);
              }
            }
            function c(t) {
              try {
                a(o.throw(t));
              } catch (t) {
                r(t);
              }
            }
            function a(t) {
              t.done ? i(t.value) : new n(function (e) {
                e(t.value);
              }).then(s, c);
            }
            a((o = o.apply(t, e || [])).next());
          });
        },
        r = this && this.__generator || function (t, e) {
          function n(t) {
            return function (e) {
              return o([t, e]);
            };
          }
          function o(n) {
            if (i) throw new TypeError("Generator is already executing.");
            for (; a;) try {
              if (i = 1, r && (s = 2 & n[0] ? r.return : n[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, n[1])).done) return s;
              switch (r = 0, s && (n = [2 & n[0], s.value]), n[0]) {
                case 0:
                case 1:
                  s = n;
                  break;
                case 4:
                  return a.label++, {
                    value: n[1],
                    done: !1
                  };
                case 5:
                  a.label++, r = n[1], n = [0];
                  continue;
                case 7:
                  n = a.ops.pop(), a.trys.pop();
                  continue;
                default:
                  if (s = a.trys, !(s = s.length > 0 && s[s.length - 1]) && (6 === n[0] || 2 === n[0])) {
                    a = 0;
                    continue;
                  }
                  if (3 === n[0] && (!s || n[1] > s[0] && n[1] < s[3])) {
                    a.label = n[1];
                    break;
                  }
                  if (6 === n[0] && a.label < s[1]) {
                    a.label = s[1], s = n;
                    break;
                  }
                  if (s && a.label < s[2]) {
                    a.label = s[2], a.ops.push(n);
                    break;
                  }
                  s[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              n = e.call(t, a);
            } catch (t) {
              n = [6, t], r = 0;
            } finally {
              i = s = 0;
            }
            if (5 & n[0]) throw n[1];
            return {
              value: n[0] ? n[1] : void 0,
              done: !0
            };
          }
          var i,
            r,
            s,
            c,
            a = {
              label: 0,
              sent: function () {
                if (1 & s[0]) throw s[1];
                return s[1];
              },
              trys: [],
              ops: []
            };
          return c = {
            next: n(0),
            throw: n(1),
            return: n(2)
          }, "function" == typeof Symbol && (c[Symbol.iterator] = function () {
            return this;
          }), c;
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.addCacheAsBackupTo = o;
    }, function (t, e, n) {
      var o = this && this.__awaiter || function (t, e, n, o) {
          return new (n || (n = Promise))(function (i, r) {
            function s(t) {
              try {
                a(o.next(t));
              } catch (t) {
                r(t);
              }
            }
            function c(t) {
              try {
                a(o.throw(t));
              } catch (t) {
                r(t);
              }
            }
            function a(t) {
              t.done ? i(t.value) : new n(function (e) {
                e(t.value);
              }).then(s, c);
            }
            a((o = o.apply(t, e || [])).next());
          });
        },
        i = this && this.__generator || function (t, e) {
          function n(t) {
            return function (e) {
              return o([t, e]);
            };
          }
          function o(n) {
            if (i) throw new TypeError("Generator is already executing.");
            for (; a;) try {
              if (i = 1, r && (s = 2 & n[0] ? r.return : n[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, n[1])).done) return s;
              switch (r = 0, s && (n = [2 & n[0], s.value]), n[0]) {
                case 0:
                case 1:
                  s = n;
                  break;
                case 4:
                  return a.label++, {
                    value: n[1],
                    done: !1
                  };
                case 5:
                  a.label++, r = n[1], n = [0];
                  continue;
                case 7:
                  n = a.ops.pop(), a.trys.pop();
                  continue;
                default:
                  if (s = a.trys, !(s = s.length > 0 && s[s.length - 1]) && (6 === n[0] || 2 === n[0])) {
                    a = 0;
                    continue;
                  }
                  if (3 === n[0] && (!s || n[1] > s[0] && n[1] < s[3])) {
                    a.label = n[1];
                    break;
                  }
                  if (6 === n[0] && a.label < s[1]) {
                    a.label = s[1], s = n;
                    break;
                  }
                  if (s && a.label < s[2]) {
                    a.label = s[2], a.ops.push(n);
                    break;
                  }
                  s[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              n = e.call(t, a);
            } catch (t) {
              n = [6, t], r = 0;
            } finally {
              i = s = 0;
            }
            if (5 & n[0]) throw n[1];
            return {
              value: n[0] ? n[1] : void 0,
              done: !0
            };
          }
          var i,
            r,
            s,
            c,
            a = {
              label: 0,
              sent: function () {
                if (1 & s[0]) throw s[1];
                return s[1];
              },
              trys: [],
              ops: []
            };
          return c = {
            next: n(0),
            throw: n(1),
            return: n(2)
          }, "function" == typeof Symbol && (c[Symbol.iterator] = function () {
            return this;
          }), c;
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var r = n(3),
        s = n(2),
        c = n(0),
        a = n(6),
        h = n(18),
        u = function () {
          function t(t, e) {
            this.state = t, this.correlationVector = void 0 !== e ? e : r.CorrelationVector.extend();
          }
          return t.prototype.getStateString = function () {
            switch (this.state) {
              case s.UserActivityState.Active:
                return "active";
              case s.UserActivityState.Inactive:
                return "inactive";
              case s.UserActivityState.Unknown:
                return "unknown";
              default:
                return "undefined";
            }
          }, t.prototype.toEventObject = function () {
            return {
              state: this.getStateString(),
              cv: this.correlationVector.value()
            };
          }, t.prototype.toEventJSON = function () {
            return r.toJson(this.toEventObject());
          }, t;
        }();
      e.UserActivityObject = u;
      var l = function () {
        function t(t, e, n, o) {
          this.logFunc = t, this.options = e, this.tokenProvider = n, this.listener = o, this.logger = new c.Logger("Manager", t), this.logger.info("Created TrouterManager with options " + r.toJson(this.options)), this.fsm = new h.TrouterManagerFsm(t, this), this.baseEndpointUrl = "", this.processedMessageLoss = {}, this.userActivityObject = new u(s.UserActivityState.Unknown);
        }
        return t.prototype.start = function () {
          this.fsm.start();
        }, t.prototype.stop = function (t) {
          this.fsm.stop(t);
        }, t.prototype.configure = function (t) {
          this.options = t, void 0 !== this.firstConnection && this.firstConnection.configure(t), void 0 !== this.secondConnection && this.secondConnection.configure(t), this.logger.info("Reconfigured TrouterManager with options " + r.toJson(this.options));
        }, t.prototype.checkConnection = function (t) {
          void 0 !== this.firstConnection && this.firstConnection.checkConnection(t), void 0 !== this.secondConnection && this.secondConnection.checkConnection(t);
        }, t.prototype.resendRegistration = function () {
          return o(this, void 0, void 0, function () {
            return i(this, function (t) {
              return void 0 !== this.secondConnection ? (this.logger.info("Resending registration on the second/new connection"), [2, this.secondConnection.resendRegistration()]) : void 0 !== this.firstConnection ? (this.logger.info("Resending registration on the first/current connection"), [2, this.firstConnection.resendRegistration()]) : (this.logger.info("No connection to resend registration on, will be done upon (re)connect"), [2]);
            });
          });
        }, t.prototype.getServerState = function () {
          if (void 0 !== this.firstConnection) return this.firstConnection.getServerState();
        }, t.prototype.getState = function () {
          return this.fsm.getState();
        }, t.prototype.startFirstConnection = function () {
          var t = new a.TrouterConnection(this.logFunc, this.options, this, this.tokenProvider, this.userActivityObject);
          this.firstConnection = t, this.getConnectionCache().then(function (e) {
            t.start(e);
          }).catch();
        }, t.prototype.startSecondConnection = function (t) {
          var e = new a.TrouterConnection(this.logFunc, this.options, this, this.tokenProvider, this.userActivityObject);
          this.secondConnection = e, void 0 !== this.firstConnection && this.firstConnection.disableRegistrationsAndAutoReconnect(), t ? this.getConnectionCache().then(function (t) {
            e.start(t);
          }).catch() : e.start();
        }, t.prototype.stopFirstConnection = function (t) {
          void 0 !== this.firstConnection && (this.storedFirstConnection = this.firstConnection, this.firstConnection.stop(t), this.firstConnection = void 0);
        }, t.prototype.stopSecondConnection = function (t) {
          void 0 !== this.secondConnection && (this.secondConnection.stop(t), this.secondConnection = void 0);
        }, t.prototype.stopSecondConnectionDelayed = function () {
          if (void 0 !== this.secondConnection) {
            var t = this.secondConnection;
            this.secondConnection = void 0, this.logger.info("Closing an inactive connection in " + Math.round(this.options.lingeringConnectionDelayMs / 1e3) + "s"), setTimeout(function () {
              t.stop(!0);
            }, this.options.lingeringConnectionDelayMs);
          }
        }, t.prototype.forceStopLingeringConnection = function () {
          this.storedFirstConnection && (this.storedFirstConnection.stop(!1), this.storedFirstConnection = void 0);
        }, t.prototype.switchConnections = function () {
          var t = this.firstConnection;
          this.firstConnection = this.secondConnection, this.secondConnection = t;
        }, t.prototype.doesSecondConnectionExist = function () {
          return void 0 !== this.secondConnection;
        }, t.prototype.dispatchConnected = function () {
          if (void 0 !== this.firstConnection) {
            var t = this.firstConnection.getServerState(),
              e = "/" === t.url.slice(-1) ? t.url.slice(0, -1) : t.url,
              n = {
                baseEndpointUrl: e,
                newEndpointUrl: e !== this.baseEndpointUrl,
                c2cUrlBase: t.c2cUrlBase,
                clientId: t.connectedClientId,
                connectionId: t.connectionId,
                connectionTtlSec: t.getRemainingTtlInSec()
              };
            this.baseEndpointUrl = e, this.listener.onTrouterConnected(t.url, n);
          }
        }, t.prototype.dispatchReconnecting = function () {
          this.listener.onTrouterDisconnected && this.listener.onTrouterDisconnected();
        }, t.prototype.dispatchStopped = function () {
          this.listener.onTrouterDisconnected && this.listener.onTrouterDisconnected();
        }, t.prototype.dispatchRegistrationState = function (t) {
          this.options.registrationStateCallback && this.options.registrationStateCallback(t);
        }, t.prototype.onDownstreamRequest = function (t, e, n) {
          var o = {
              id: e.id,
              method: e.method,
              path: "/" + e.shortUrl,
              body: e.body,
              headers: e.headers
            },
            i = {
              id: e.id,
              status: 0,
              headers: {},
              body: "",
              send: function () {
                return i.status <= 100 || i.status >= 999 ? 3 : (n.writeHead(i.status, i.headers), n.end(i.body));
              }
            };
          this.listener.onTrouterRequest(o, i);
        }, t.prototype.onConnected = function (t) {
          this.fsm.onConnected(t === this.firstConnection);
        }, t.prototype.onRegistered = function (t) {
          this.fsm.onRegistered(t === this.firstConnection);
        }, t.prototype.onUnregistered = function (t) {
          this.fsm.onUnregistered(t === this.firstConnection || t === this.storedFirstConnection);
        }, t.prototype.onReconnecting = function (t) {
          this.fsm.onReconnecting(t === this.firstConnection);
        }, t.prototype.onReconnectIsRequired = function (t, e, n) {
          this.fsm.onReconnectionRequired(t === this.firstConnection, e, n);
        }, t.prototype.onDisconnected = function (t) {
          this.fsm.onDisconnected(t === this.storedFirstConnection), this.storedFirstConnection = void 0;
        }, t.prototype.onUserActivityStateAccepted = function (t) {
          this.listener.onTrouterUserActivityStateAccepted && this.listener.onTrouterUserActivityStateAccepted(t);
        }, t.prototype.onConnectionParametersUpdated = function (t) {
          this.setConnectionCache(t);
        }, t.prototype.setUserActivityState = function (t, e) {
          return this.userActivityObject = new u(t, r.CorrelationVector.extend(e)), void 0 !== this.secondConnection ? (this.logger.info("Setting user activity " + this.userActivityObject.toEventJSON() + " on the second/new connection"), void this.secondConnection.setUserActivityState(this.userActivityObject)) : void 0 !== this.firstConnection ? (this.logger.info("Setting user activity " + this.userActivityObject.toEventJSON() + " on the first/current connection"), void this.firstConnection.setUserActivityState(this.userActivityObject)) : void 0;
        }, t.prototype.onTrouterMessageLost = function (t) {
          var e = this;
          if (this.listener.onTrouterMessageLoss) if (t && t.length) {
            var n = t.filter(function (t) {
              return void 0 !== e.processedMessageLoss[t.tag + "-" + t.etag];
            });
            if (n.length && (this.logger.warn("onTrouterMessageLoss - removing duplicates and sending event to server"), this.sendProcessedDroppedIndicators(n), t = t.filter(function (t) {
              return void 0 === e.processedMessageLoss[t.tag + "-" + t.etag];
            }), !t.length)) return void this.logger.warn("onTrouterMessageLoss - All the data are duplicated");
            var o = this.listener.onTrouterMessageLoss(t.map(function (t) {
              return t.tag;
            }));
            if (!o) return void this.logger.warn("onTrouterMessageLoss - flow tags have not been processed by listeners");
            t.forEach(function (t) {
              e.processedMessageLoss[t.tag + "-" + t.etag] = "";
            }), this.sendProcessedDroppedIndicators(t);
          } else this.logger.warn("onTrouterMessageLoss - no flow tags have been provided");
        }, t.prototype.getConnectionCache = function () {
          var t = this;
          return this.options.connectionCache ? (this.logger.debug("Querying host's connection cache"), this.options.connectionCache.onGetTrouterConnectionCache().then(function (t) {
            return t ? JSON.parse(t) : void 0;
          }).catch(function (e) {
            return t.logger.warn("Invalid connection cache content provided: " + e), t.connectionCache;
          })) : Promise.resolve(this.connectionCache);
        }, t.prototype.setConnectionCache = function (t) {
          if (this.connectionCache = t, this.options.connectionCache) try {
            this.options.connectionCache.onSetTrouterConnectionCache(JSON.stringify(t));
          } catch (t) {
            this.logger.warn("Error setting external connection cache: " + t);
          }
        }, t.prototype.sendProcessedDroppedIndicators = function (t) {
          return void 0 !== this.firstConnection ? void this.firstConnection.sendProcessedDroppedIndicators(t) : void 0 !== this.secondConnection ? void this.secondConnection.sendProcessedDroppedIndicators(t) : void 0;
        }, t;
      }();
      e.TrouterManager = l;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = function () {
        function t(t) {
          this.logger = t;
        }
        return t.prototype.getPromise = function () {
          var t = this;
          return void 0 !== this.url ? (this.logger.debug("[TrouterUrlPromise] returning previously resolved url: " + this.url), Promise.resolve(this.url)) : (void 0 === this.pendingPromise ? (this.logger.debug("[TrouterUrlPromise] creating and returning promise"), this.pendingPromise = new Promise(function (e, n) {
            t.pendingPromiseResolveRef = e, t.pendingPromiseRejectRef = n;
          })) : this.logger.debug("[TrouterUrlPromise] returning existing promise"), this.pendingPromise);
        }, t.prototype.resolveUrl = function (t) {
          this.url = t, this.logger.debug("[TrouterUrlPromise] got url: " + this.url);
          var e = this.pendingPromiseResolveRef;
          this.pendingPromise = void 0, this.pendingPromiseResolveRef = void 0, this.pendingPromiseRejectRef = void 0, void 0 !== e && (this.logger.debug("[TrouterUrlPromise] resolving promise"), e(t));
        }, t.prototype.rejectUrl = function (t) {
          this.logger.debug("[TrouterUrlPromise] aborting");
          var e = this.pendingPromiseRejectRef;
          this.url = void 0, this.pendingPromise = void 0, this.pendingPromiseResolveRef = void 0, this.pendingPromiseRejectRef = void 0, void 0 !== e && (this.logger.debug("[TrouterUrlPromise] rejecting promise"), e(t));
        }, t.prototype.resetUrl = function () {
          this.logger.debug("[TrouterUrlPromise] resetting url"), this.url = void 0;
        }, t;
      }();
      e.TrouterUrlPromise = o;
    }, function (t, e, n) {
      (function (t, n) {
        !function (t, e) {
          var n = t;
          n.version = "0.9.6", n.protocol = 1, n.transports = [], n.j = [], n.sockets = {}, n.connect = function (t, o) {
            var i,
              r,
              s = n.util.parseUri(t);
            e && e.location && (s.protocol = s.protocol || e.location.protocol.slice(0, -1), s.host = s.host || (e.document ? e.document.domain : e.location.hostname), s.port = s.port || e.location.port), i = n.util.uniqueUri(s);
            var c = {
              host: s.host,
              secure: "https" == s.protocol,
              port: s.port || ("https" == s.protocol ? 443 : 80),
              query: s.query || ""
            };
            return n.util.merge(c, o), !c["force new connection"] && n.sockets[i] || (r = new n.Socket(c)), !c["force new connection"] && r && (n.sockets[i] = r), r = r || n.sockets[i], r.of(s.path.length > 1 ? s.path : "");
          };
        }(n.exports, void 0 === t ? window : t);
        var o = n.exports;
        !function (t, e) {
          var n = t.util = {},
            o = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
            i = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];
          n.parseUri = function (t) {
            for (var e = o.exec(t || ""), n = {}, r = 14; r--;) n[i[r]] = e[r] || "";
            return n;
          }, n.uniqueUri = function (t) {
            var n = t.protocol,
              o = t.host,
              i = t.port;
            return "document" in e ? (o = o || document.domain, i = i || ("https" == n && "https:" !== document.location.protocol ? 443 : document.location.port)) : (o = o || "localhost", i || "https" != n || (i = 443)), (n || "http") + "://" + o + ":" + (i || 80);
          }, n.query = function (t, e) {
            var o = n.chunkQuery(t || ""),
              i = [];
            n.merge(o, n.chunkQuery(e || ""));
            for (var r in o) o.hasOwnProperty(r) && i.push(r + "=" + o[r]);
            return i.length ? "?" + i.join("&") : "";
          }, n.chunkQuery = function (t) {
            for (var e, n = {}, o = t.split("&"), i = 0, r = o.length; i < r; ++i) e = o[i].split("="), e[0] && (n[e[0]] = e[1]);
            return n;
          };
          var r = !1;
          n.load = function (t) {
            if ("document" in e && "complete" === document.readyState || r) return t();
            n.on(e, "load", t, !1);
          }, n.on = function (t, e, n, o) {
            t.attachEvent ? t.attachEvent("on" + e, n) : t.addEventListener && t.addEventListener(e, n, o);
          }, n.request = function (t) {
            if (t && "undefined" != typeof XDomainRequest) return new XDomainRequest();
            if ("undefined" != typeof XMLHttpRequest && (!t || n.ua.hasCORS)) return new XMLHttpRequest();
            if (!t) try {
              return new window[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
            } catch (t) {}
            return null;
          }, "undefined" != typeof window && n.load(function () {
            r = !0;
          }), n.defer = function (t) {
            if (!n.ua.webkit || "undefined" != typeof importScripts) return t();
            n.load(function () {
              setTimeout(t, 100);
            });
          }, n.merge = function (t, e, o, i) {
            var r,
              s = i || [],
              c = void 0 === o ? 2 : o;
            for (r in e) e.hasOwnProperty(r) && n.indexOf(s, r) < 0 && ("object" == typeof t[r] && c ? n.merge(t[r], e[r], c - 1, s) : (t[r] = e[r], s.push(e[r])));
            return t;
          }, n.mixin = function (t, e) {
            n.merge(t.prototype, e.prototype);
          }, n.inherit = function (t, e) {
            function n() {}
            n.prototype = e.prototype, t.prototype = new n();
          }, n.isArray = Array.isArray || function (t) {
            return "[object Array]" === Object.prototype.toString.call(t);
          }, n.intersect = function (t, e) {
            for (var o = [], i = t.length > e.length ? t : e, r = t.length > e.length ? e : t, s = 0, c = r.length; s < c; s++) ~n.indexOf(i, r[s]) && o.push(r[s]);
            return o;
          }, n.indexOf = function (t, e, n) {
            for (var o = t.length, n = n < 0 ? n + o < 0 ? 0 : n + o : n || 0; n < o && t[n] !== e; n++);
            return o <= n ? -1 : n;
          }, n.toArray = function (t) {
            for (var e = [], n = 0, o = t.length; n < o; n++) e.push(t[n]);
            return e;
          }, n.ua = {}, n.ua.hasCORS = "undefined" != typeof XMLHttpRequest && function () {
            try {
              var t = new XMLHttpRequest();
            } catch (t) {
              return !1;
            }
            return void 0 != t.withCredentials;
          }(), n.ua.webkit = "undefined" != typeof navigator && /webkit/i.test(navigator.userAgent);
        }(void 0 !== o ? o : n.exports, void 0 === t ? window : t), function (t, e) {
          function n() {}
          t.EventEmitter = n, n.prototype.on = function (t, n) {
            return this.$events || (this.$events = {}), this.$events[t] ? e.util.isArray(this.$events[t]) ? this.$events[t].push(n) : this.$events[t] = [this.$events[t], n] : this.$events[t] = n, this;
          }, n.prototype.addListener = n.prototype.on, n.prototype.once = function (t, e) {
            function n() {
              o.removeListener(t, n), e.apply(this, arguments);
            }
            var o = this;
            return n.listener = e, this.on(t, n), this;
          }, n.prototype.removeListener = function (t, n) {
            if (this.$events && this.$events[t]) {
              var o = this.$events[t];
              if (e.util.isArray(o)) {
                for (var i = -1, r = 0, s = o.length; r < s; r++) if (o[r] === n || o[r].listener && o[r].listener === n) {
                  i = r;
                  break;
                }
                if (i < 0) return this;
                o.splice(i, 1), o.length || delete this.$events[t];
              } else (o === n || o.listener && o.listener === n) && delete this.$events[t];
            }
            return this;
          }, n.prototype.removeAllListeners = function (t) {
            return this.$events && this.$events[t] && (this.$events[t] = null), this;
          }, n.prototype.listeners = function (t) {
            return this.$events || (this.$events = {}), this.$events[t] || (this.$events[t] = []), e.util.isArray(this.$events[t]) || (this.$events[t] = [this.$events[t]]), this.$events[t];
          }, n.prototype.emit = function (t) {
            if (!this.$events) return !1;
            var n = this.$events[t];
            if (!n) return !1;
            var o = Array.prototype.slice.call(arguments, 1);
            if ("function" == typeof n) n.apply(this, o);else {
              if (!e.util.isArray(n)) return !1;
              for (var i = n.slice(), r = 0, s = i.length; r < s; r++) i[r].apply(this, o);
            }
            return !0;
          };
        }(void 0 !== o ? o : n.exports, void 0 !== o ? o : n.parent.exports), function (t, e) {
          if (e && e.parse) return t.JSON = {
            parse: e.parse,
            stringify: e.stringify
          };
          throw new Error("JSON not available");
        }(void 0 !== o ? o : n.exports, "undefined" != typeof JSON ? JSON : void 0), function (t, e) {
          var n = t.parser = {},
            o = n.packets = ["disconnect", "connect", "heartbeat", "message", "json", "event", "ack", "error", "noop"],
            i = n.reasons = ["transport not supported", "client not handshaken", "unauthorized"],
            r = n.advice = ["reconnect"],
            s = e.JSON,
            c = e.util.indexOf;
          n.encodePacket = function (t) {
            var e = c(o, t.type),
              n = t.id || "",
              a = t.endpoint || "",
              h = t.ack,
              u = null;
            switch (t.type) {
              case "error":
                var l = t.reason ? c(i, t.reason) : "",
                  p = t.advice ? c(r, t.advice) : "";
                "" === l && "" === p || (u = l + ("" !== p ? "+" + p : ""));
                break;
              case "message":
                "" !== t.data && (u = t.data);
                break;
              case "event":
                var d = {
                  name: t.name
                };
                t.args && t.args.length && (d.args = t.args), u = s.stringify(d);
                break;
              case "json":
                u = s.stringify(t.data);
                break;
              case "connect":
                t.qs && (u = t.qs);
                break;
              case "ack":
                u = t.ackId + (t.args && t.args.length ? "+" + s.stringify(t.args) : "");
            }
            var g = [e, n + ("data" == h ? "+" : ""), a];
            return null !== u && void 0 !== u && g.push(u), g.join(":");
          }, n.encodePayload = function (t) {
            var e = "";
            if (1 == t.length) return t[0];
            for (var n = 0, o = t.length; n < o; n++) {
              e += "�" + t[n].length + "�" + t[n];
            }
            return e;
          };
          var a = /([^:]+):([0-9]+)?(\+)?:([^:]+)?:?([\s\S]*)?/;
          n.decodePacket = function (t) {
            var e = t.match(a);
            if (!e) return {};
            var n = e[2] || "",
              t = e[5] || "",
              c = {
                type: o[e[1]],
                endpoint: e[4] || ""
              };
            switch (n && (c.id = n, e[3] ? c.ack = "data" : c.ack = !0), c.type) {
              case "error":
                var e = t.split("+");
                c.reason = i[e[0]] || "", c.advice = r[e[1]] || "";
                break;
              case "message":
                c.data = t || "";
                break;
              case "event":
                try {
                  var h = s.parse(t);
                  c.name = h.name, c.args = h.args;
                } catch (t) {}
                c.args = c.args || [];
                break;
              case "json":
                try {
                  c.data = s.parse(t);
                } catch (t) {}
                break;
              case "connect":
                c.qs = t || "";
                break;
              case "ack":
                var e = t.match(/^([0-9]+)(\+)?(.*)/);
                if (e && (c.ackId = e[1], c.args = [], e[3])) try {
                  c.args = e[3] ? s.parse(e[3]) : [];
                } catch (t) {}
                break;
              case "disconnect":
                c.reason = t;
            }
            return c;
          }, n.decodePayload = function (t) {
            if ("�" == t.charAt(0)) {
              for (var e = [], o = 1, i = ""; o < t.length; o++) "�" == t.charAt(o) ? (e.push(n.decodePacket(t.substr(o + 1).substr(0, i))), o += Number(i) + 1, i = "") : i += t.charAt(o);
              return e;
            }
            return [n.decodePacket(t)];
          };
        }(void 0 !== o ? o : n.exports, void 0 !== o ? o : n.parent.exports), function (t, e) {
          function n(t, e) {
            this.socket = t, this.sessid = e, this.connectErrorCallback = void 0, this.isOpened = !1;
          }
          t.Transport = n, e.util.mixin(n, e.EventEmitter), n.prototype.onData = function (t) {
            if (this.clearCloseTimeout(), (this.socket.connected || this.socket.connecting || this.socket.reconnecting) && this.setCloseTimeout(), "" !== t) {
              var n = e.parser.decodePayload(t);
              if (n && n.length) for (var o = 0, i = n.length; o < i; o++) this.onPacket(n[o]);
            }
            return this;
          }, n.prototype.onPacket = function (t) {
            return this.socket.setHeartbeatTimeout(), "heartbeat" == t.type ? this.onHeartbeat() : ("connect" == t.type && "" == t.endpoint && this.onConnect(), "error" == t.type && "reconnect" == t.advice && (this.isOpened = !1), this.socket.onPacket(t), this);
          }, n.prototype.setCloseTimeout = function () {
            if (!this.closeTimeout) {
              var t = this;
              this.closeTimeout = setTimeout(function () {
                t.onDisconnect();
              }, this.socket.closeTimeout);
            }
          }, n.prototype.onDisconnect = function () {
            return this.close && this.isOpened && this.close(), this.clearTimeouts(), this.socket.onDisconnect(), this;
          }, n.prototype.onConnect = function () {
            return this.socket.onConnect(), this.connectErrorCallback = void 0, this;
          }, n.prototype.clearCloseTimeout = function () {
            this.closeTimeout && (clearTimeout(this.closeTimeout), this.closeTimeout = null);
          }, n.prototype.clearTimeouts = function () {
            this.clearCloseTimeout(), this.reopenTimeout && clearTimeout(this.reopenTimeout);
          }, n.prototype.packet = function (t) {
            this.send(e.parser.encodePacket(t));
          }, n.prototype.onHeartbeat = function (t) {
            this.packet({
              type: "heartbeat"
            });
          }, n.prototype.onOpen = function () {
            this.isOpened = !0, this.clearCloseTimeout(), this.socket.onOpen();
          }, n.prototype.onClose = function () {
            this.isOpened = !1, this.socket.onClose(), this.onDisconnect();
          }, n.prototype.prepareUrl = function () {
            var t = this.socket.options;
            return this.scheme() + "://" + t.host + ":" + t.port + "/" + t.resource + "/" + e.protocol + "/" + this.name + "/" + this.sessid;
          }, n.prototype.ready = function (t, e) {
            e.call(this);
          }, n.prototype.clearEventHandlers = function () {
            return this;
          };
        }(void 0 !== o ? o : n.exports, void 0 !== o ? o : n.parent.exports), function (t, e, n) {
          function o(t) {
            if (this.options = {
              port: 80,
              secure: !1,
              document: "document" in n && document,
              resource: "socket.io",
              transports: e.transports.slice(),
              "connect timeout": 1e4,
              "try multiple transports": !0,
              reconnect: !0,
              "reconnection delay": 500,
              "reconnection limit": 1 / 0,
              "reopen delay": 3e3,
              "max reconnection attempts": 10,
              "sync disconnect on unload": !0,
              "auto connect": !0,
              "flash policy port": 10843
            }, e.util.merge(this.options, t), this.connected = !1, this.open = !1, this.connecting = !1, this.reconnecting = !1, this.namespaces = {}, this.buffer = [], this.doBuffer = !1, this.disconnected = !1, this.options["sync disconnect on unload"] && (!this.isXDomain() || e.util.ua.hasCORS)) {
              var o = this;
              e.util.on(n, "unload", function () {
                o.disconnectSync();
              }, !1);
            }
            this.options["auto connect"] && this.connect();
          }
          function i() {}
          t.Socket = o, e.util.mixin(o, e.EventEmitter), o.prototype.of = function (t) {
            return this.namespaces[t] || (this.namespaces[t] = new e.SocketNamespace(this, t), "" !== t && this.namespaces[t].packet({
              type: "connect"
            })), this.namespaces[t];
          }, o.prototype.publish = function () {
            this.emit.apply(this, arguments);
            var t;
            for (var e in this.namespaces) this.namespaces.hasOwnProperty(e) && (t = this.of(e), t.$emit.apply(t, arguments));
          }, o.prototype.handshake = function (t) {
            function n(e) {
              e instanceof Error ? o.onError(e.message) : t.apply(null, e.split(":"));
            }
            var o = this,
              r = this.options;
            if (!o.disconnected) {
              var s = ["http" + (r.secure ? "s" : "") + ":/", r.host + ":" + r.port, r.resource, e.protocol, e.util.query(this.options.query, "t=" + +new Date())].join("/");
              if (this.isXDomain() && !e.util.ua.hasCORS) {
                var c = document.getElementsByTagName("script")[0],
                  a = document.createElement("script");
                a.src = s + "&jsonp=" + e.j.length, c.parentNode.insertBefore(a, c), e.j.push(function (t) {
                  n(t), a.parentNode.removeChild(a);
                });
              } else {
                var h = e.util.request();
                h.open("GET", s, !0), h.onreadystatechange = function () {
                  4 == h.readyState && (h.onreadystatechange = i, 200 == h.status ? n(h.responseText) : !o.reconnecting && o.onError(h.responseText));
                }, h.send(null);
              }
            }
          }, o.prototype.getTransport = function (t) {
            for (var n, o = t || this.transports, i = 0; n = o[i]; i++) if (e.Transport[n] && e.Transport[n].check(this) && (!this.isXDomain() || e.Transport[n].xdomainCheck())) return new e.Transport[n](this, this.sessionid);
            return null;
          }, o.prototype.connect = function (t) {
            if (this.connecting || this.disconnected) return this;
            var n = this;
            return this.handshake(function (o, i, r, s) {
              function c() {
                if (!n.connected && !n.disconnected) if (n.connecting = !1, clearTimeout(n.connectTimeoutTimer), n.options["try multiple transports"]) {
                  for (; n.remainingTransports.length > 0 && n.remainingTransports.splice(0, 1)[0] != n.transport.name;);
                  n.remainingTransports.length ? a(n.remainingTransports) : n.publish("connect_failed");
                } else n.publish("connect_failed");
              }
              function a(t) {
                if (n.transport && (n.transport.clearTimeouts(), n.transport.clearEventHandlers()), n.transport = n.getTransport(t), !n.transport || n.disconnected) return n.publish("connect_failed");
                n.transport.ready(n, function () {
                  n.connecting = !0, n.publish("connecting", n.transport.name), n.transport.open(c), n.options["connect timeout"] && (n.connectTimeoutTimer = setTimeout(function () {
                    c();
                  }, n.options["connect timeout"]));
                });
              }
              n.sessionid = o, n.closeTimeout = 1e3 * r + 2e3, n.heartbeatTimeout = 1e3 * i + 2e3, n.transports = s ? e.util.intersect(s.split(","), n.options.transports) : n.options.transports, n.setHeartbeatTimeout(), n.remainingTransports = n.transports.slice(0), a(n.transports), n.once("connect", function () {
                clearTimeout(n.connectTimeoutTimer), t && "function" == typeof t && t();
              });
            }), this;
          }, o.prototype.setHeartbeatTimeout = function () {
            clearTimeout(this.heartbeatTimeoutTimer);
            var t = this;
            this.heartbeatTimeoutTimer = setTimeout(function () {
              t.transport.onClose();
            }, this.heartbeatTimeout);
          }, o.prototype.packet = function (t) {
            return this.connected && !this.doBuffer ? this.transport.packet(t) : this.buffer.push(t), this;
          }, o.prototype.setBuffer = function (t) {
            this.doBuffer = t, !t && this.connected && this.buffer.length && (this.transport.payload(this.buffer), this.buffer = []);
          }, o.prototype.disconnect = function () {
            return (this.connected || this.connecting) && (this.open && this.of("").packet({
              type: "disconnect"
            }), this.onDisconnect("booted")), this.disconnected = !0, this;
          }, o.prototype.disconnectSync = function () {
            var t = e.util.request(),
              n = this.resource + "/" + e.protocol + "/" + this.sessionid;
            t.open("GET", n, !0), this.onDisconnect("booted");
          }, o.prototype.isXDomain = function () {
            var t = n.location.port || ("https:" == n.location.protocol ? 443 : 80);
            return this.options.host !== n.location.hostname || this.options.port != t;
          }, o.prototype.onConnect = function () {
            this.connected || (this.connected = !0, this.connecting = !1, this.doBuffer || this.setBuffer(!1), this.emit("connect"));
          }, o.prototype.onOpen = function () {
            this.open = !0;
          }, o.prototype.onClose = function () {
            this.open = !1, clearTimeout(this.heartbeatTimeoutTimer);
          }, o.prototype.onPacket = function (t) {
            this.of(t.endpoint).onPacket(t);
          }, o.prototype.onError = function (t) {
            t && t.advice && "reconnect" === t.advice && (this.connected || this.connecting) && (this.disconnect(), this.options.reconnect && this.reconnect()), this.publish("error", t && t.reason ? t.reason : t);
          }, o.prototype.onDisconnect = function (t) {
            var e = this.connected,
              n = this.connecting;
            this.connected = !1, this.connecting = !1, this.open = !1, (e || n) && (this.transport.close(), this.transport.clearTimeouts(), e && (this.publish("disconnect", t), "booted" != t && this.options.reconnect && !this.reconnecting && this.reconnect()));
          }, o.prototype.reconnect = function () {
            function t() {
              if (n.connected) {
                for (var t in n.namespaces) n.namespaces.hasOwnProperty(t) && "" !== t && n.namespaces[t].packet({
                  type: "connect"
                });
                n.publish("reconnect", n.transport.name, n.reconnectionAttempts);
              }
              clearTimeout(n.reconnectionTimer), n.removeListener("connect_failed", e), n.removeListener("connect", e), n.reconnecting = !1, delete n.reconnectionAttempts, delete n.reconnectionDelay, delete n.reconnectionTimer, delete n.redoTransports, n.options["try multiple transports"] = i;
            }
            function e() {
              if (n.reconnecting) return n.connected ? t() : n.connecting && n.reconnecting ? n.reconnectionTimer = setTimeout(e, 1e3) : void (n.reconnectionAttempts++ >= o ? n.redoTransports ? (n.publish("reconnect_failed"), t()) : (n.on("connect_failed", e), n.options["try multiple transports"] = !0, n.transport = n.getTransport(), n.redoTransports = !0, n.connect()) : (n.reconnectionDelay < r && (n.reconnectionDelay *= 2), n.connect(), n.publish("reconnecting", n.reconnectionDelay, n.reconnectionAttempts), n.reconnectionTimer = setTimeout(e, n.reconnectionDelay)));
            }
            this.reconnecting = !0, this.reconnectionAttempts = 0, this.reconnectionDelay = this.options["reconnection delay"];
            var n = this,
              o = this.options["max reconnection attempts"],
              i = this.options["try multiple transports"],
              r = this.options["reconnection limit"];
            this.options["try multiple transports"] = !1, this.reconnectionTimer = setTimeout(e, this.reconnectionDelay), this.on("connect", e);
          };
        }(void 0 !== o ? o : n.exports, void 0 !== o ? o : n.parent.exports, void 0 === t ? window : t), function (t, e) {
          function n(t, e) {
            this.socket = t, this.name = e || "", this.flags = {}, this.json = new o(this, "json"), this.ackPackets = 0, this.acks = {};
          }
          function o(t, e) {
            this.namespace = t, this.name = e;
          }
          t.SocketNamespace = n, e.util.mixin(n, e.EventEmitter), n.prototype.$emit = e.EventEmitter.prototype.emit, n.prototype.of = function () {
            return this.socket.of.apply(this.socket, arguments);
          }, n.prototype.packet = function (t) {
            return t.endpoint = this.name, this.socket.packet(t), this.flags = {}, this;
          }, n.prototype.send = function (t, e) {
            var n = {
              type: this.flags.json ? "json" : "message",
              data: t
            };
            return "function" == typeof e && (n.id = ++this.ackPackets, n.ack = !0, this.acks[n.id] = e), this.packet(n);
          }, n.prototype.emit = function (t) {
            var e = Array.prototype.slice.call(arguments, 1),
              n = e[e.length - 1],
              o = {
                type: "event",
                name: t
              };
            return "function" == typeof n && (o.id = ++this.ackPackets, o.ack = "data", this.acks[o.id] = n, e = e.slice(0, e.length - 1)), o.args = e, this.packet(o);
          }, n.prototype.disconnect = function () {
            return "" === this.name ? this.socket.disconnect() : (this.packet({
              type: "disconnect"
            }), this.$emit("disconnect")), this;
          }, n.prototype.onPacket = function (t) {
            function n() {
              o.packet({
                type: "ack",
                args: e.util.toArray(arguments),
                ackId: t.id
              });
            }
            var o = this;
            switch (t.type) {
              case "connect":
                this.$emit("connect");
                break;
              case "disconnect":
                "" === this.name ? this.socket.onDisconnect(t.reason || "booted") : this.$emit("disconnect", t.reason || "");
                break;
              case "message":
              case "json":
                var i = ["message", t.data];
                "data" == t.ack ? i.push(n) : t.ack && this.packet({
                  type: "ack",
                  ackId: t.id
                }), this.$emit.apply(this, i);
                break;
              case "event":
                var i = [t.name].concat(t.args);
                "data" == t.ack && i.push(n), this.$emit.apply(this, i);
                break;
              case "ack":
                this.acks[t.ackId] && (this.acks[t.ackId].apply(this, t.args), delete this.acks[t.ackId]);
                break;
              case "error":
                t.advice ? this.socket.onError(t) : "unauthorized" == t.reason ? this.$emit("connect_failed", t.reason) : this.$emit("error", t.reason);
            }
          }, o.prototype.send = function () {
            this.namespace.flags[this.name] = !0, this.namespace.send.apply(this.namespace, arguments);
          }, o.prototype.emit = function () {
            this.namespace.flags[this.name] = !0, this.namespace.emit.apply(this.namespace, arguments);
          };
        }(void 0 !== o ? o : n.exports, void 0 !== o ? o : n.parent.exports), function (t, e, n) {
          function o(t) {
            e.Transport.apply(this, arguments);
          }
          function i() {}
          t.websocket = o, e.util.inherit(o, e.Transport), o.prototype.name = "websocket", o.prototype.open = function (t) {
            var o,
              i = e.util.query(this.socket.options.query),
              r = this;
            return this.connectErrorCallback = t, o || (o = n.MozWebSocket || n.WebSocket), this.websocket = new o(this.prepareUrl() + i), this.websocket.onopen = function () {
              r.onOpen(), r.socket.setBuffer(!1);
            }, this.websocket.onmessage = function (t) {
              r.onData(t.data);
            }, this.websocket.onclose = function () {
              r.onClose(), r.socket.setBuffer(!0);
            }, this.websocket.onerror = function (t) {
              r.onError(t);
            }, this;
          }, o.prototype.send = function (t) {
            return this.websocket.send(t), this;
          }, o.prototype.payload = function (t) {
            for (var e = 0, n = t.length; e < n; e++) this.packet(t[e]);
            return this;
          }, o.prototype.close = function () {
            return this.websocket.close(), this;
          }, o.prototype.onError = function (t) {
            void 0 !== this.connectErrorCallback && (this.connectErrorCallback(), this.connectErrorCallback = void 0), this.socket.onError(t);
          }, o.prototype.scheme = function () {
            return this.socket.options.secure ? "wss" : "ws";
          }, o.check = function () {
            return "WebSocket" in n && !("__addTask" in WebSocket) || "MozWebSocket" in n;
          }, o.xdomainCheck = function () {
            return !0;
          }, o.prototype.clearEventHandlers = function () {
            return this.websocket && (this.websocket.onopen = this.websocket.onmessage = this.websocket.onclose = this.websocket.onerror = i), this;
          }, e.transports.push("websocket");
        }(void 0 !== o ? o.Transport : n.exports, void 0 !== o ? o : n.parent.exports, void 0 === t ? window : t), function (t, e, n) {
          function o(t) {
            t && (e.Transport.apply(this, arguments), this.sendBuffer = []);
          }
          function i() {}
          t.XHR = o, e.util.inherit(o, e.Transport), o.prototype.open = function () {
            return this.socket.setBuffer(!1), this.onOpen(), this.get(), this.setCloseTimeout(), this;
          }, o.prototype.payload = function (t) {
            for (var n = [], o = 0, i = t.length; o < i; o++) n.push(e.parser.encodePacket(t[o]));
            this.send(e.parser.encodePayload(n));
          }, o.prototype.send = function (t) {
            return this.post(t), this;
          }, o.prototype.post = function (t) {
            function e() {
              4 == this.readyState && (this.onreadystatechange = i, r.posting = !1, 200 == this.status ? (r.socket.setBuffer(!1), clearTimeout(r.sendXHR.ackTimeoutTimer)) : r.onClose());
            }
            function o() {
              this.onload = i, r.socket.setBuffer(!1);
            }
            var r = this;
            this.socket.setBuffer(!0), this.sendXHR = this.request("POST"), n.XDomainRequest && this.sendXHR instanceof XDomainRequest ? this.sendXHR.onload = this.sendXHR.onerror = o : this.sendXHR.onreadystatechange = e, this.sendXHR.send(t), r.sendXHR.ackTimeoutTimer = setTimeout(function () {
              r.onClose();
            }, r.socket.options.ackTimeoutMs);
          }, o.prototype.close = function () {
            return this.onClose(), this;
          }, o.prototype.request = function (t) {
            var n = e.util.request(this.socket.isXDomain()),
              o = e.util.query(this.socket.options.query, "t=" + +new Date());
            if (n.open(t || "GET", this.prepareUrl() + o, !0), "POST" == t) try {
              n.setRequestHeader ? n.setRequestHeader("Content-type", "text/plain;charset=UTF-8") : n.contentType = "text/plain";
            } catch (t) {}
            return n;
          }, o.prototype.scheme = function () {
            return this.socket.options.secure ? "https" : "http";
          }, o.check = function (t, o) {
            try {
              var i = e.util.request(o),
                r = n.XDomainRequest && i instanceof XDomainRequest,
                s = t && t.options && t.options.secure ? "https:" : "http:",
                c = s != n.location.protocol;
              if (i && (!r || !c)) return !0;
            } catch (t) {}
            return !1;
          }, o.xdomainCheck = function () {
            return o.check(null, !0);
          }, o.prototype.clearEventHandlers = function () {
            return this.sendXHR && (this.sendXHR.onreadystatechange = this.sendXHR.onload = i), this;
          };
        }(void 0 !== o ? o.Transport : n.exports, void 0 !== o ? o : n.parent.exports, void 0 === t ? window : t), function (t, e, n) {
          function o() {
            e.Transport.XHR.apply(this, arguments);
          }
          function i() {}
          t["xhr-polling"] = o, e.util.inherit(o, e.Transport.XHR), e.util.merge(o, e.Transport.XHR), o.prototype.name = "xhr-polling", o.prototype.open = function (t) {
            var n = this;
            return n.connectErrorCallback = t, e.Transport.XHR.prototype.open.call(n), !1;
          }, o.prototype.get = function () {
            function t() {
              4 == this.readyState && (this.onreadystatechange = i, 200 == this.status ? (r.connectErrorCallback = void 0, r.onData(this.responseText), r.get()) : (r.onClose(), void 0 !== r.connectErrorCallback && (r.connectErrorCallback(), r.connectErrorCallback = void 0)));
            }
            function e() {
              r.connectErrorCallback = void 0, this.onload = i, this.onerror = i, r.onData(this.responseText), r.get();
            }
            function o() {
              r.onClose(), void 0 !== r.connectErrorCallback && (r.connectErrorCallback(), r.connectErrorCallback = void 0);
            }
            if (this.isOpened) {
              var r = this;
              this.xhr = this.request(), n.XDomainRequest && this.xhr instanceof XDomainRequest ? (this.xhr.onload = e, this.xhr.onerror = o) : this.xhr.onreadystatechange = t, this.xhr.send(null);
            }
          }, o.prototype.onClose = function () {
            if (e.Transport.XHR.prototype.onClose.call(this), this.xhr) {
              this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = i;
              try {
                this.xhr.abort();
              } catch (t) {}
              this.xhr = null;
            }
          }, o.prototype.ready = function (t, n) {
            var o = this;
            e.util.defer(function () {
              n.call(o);
            });
          }, o.prototype.clearEventHandlers = function () {
            return e.Transport.XHR.prototype.clearEventHandlers.call(this), this.xhr && (this.xhr.onreadystatechange = this.xhr.onload = this.xhr.onerror = i), this;
          }, e.transports.push("xhr-polling");
        }(void 0 !== o ? o.Transport : n.exports, void 0 !== o ? o : n.parent.exports, void 0 === t ? window : t), e.io = o;
      }).call(e, n(4), n(14)(t));
    }, function (t, e, n) {
      (function (e, o) {
        /*!
        * @overview es6-promise - a tiny implementation of Promises/A+.
        * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
        * @license   Licensed under MIT license
        *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
        * @version   4.0.5
        */
        !function (e, n) {
          t.exports = n();
        }(0, function () {
          function t(t) {
            return "function" == typeof t || "object" == typeof t && null !== t;
          }
          function i(t) {
            return "function" == typeof t;
          }
          function r(t) {
            $ = t;
          }
          function s(t) {
            V = t;
          }
          function c() {
            return void 0 !== X ? function () {
              X(h);
            } : a();
          }
          function a() {
            var t = setTimeout;
            return function () {
              return t(h, 1);
            };
          }
          function h() {
            for (var t = 0; t < J; t += 2) {
              (0, Y[t])(Y[t + 1]), Y[t] = void 0, Y[t + 1] = void 0;
            }
            J = 0;
          }
          function u(t, e) {
            var n = arguments,
              o = this,
              i = new this.constructor(p);
            void 0 === i[tt] && O(i);
            var r = o._state;
            return r ? function () {
              var t = n[r - 1];
              V(function () {
                return P(r, i, t, o._result);
              });
            }() : b(o, i, t, e), i;
          }
          function l(t) {
            var e = this;
            if (t && "object" == typeof t && t.constructor === e) return t;
            var n = new e(p);
            return k(n, t), n;
          }
          function p() {}
          function d() {
            return new TypeError("You cannot resolve a promise with itself");
          }
          function g() {
            return new TypeError("A promises callback cannot return that same promise.");
          }
          function f(t) {
            try {
              return t.then;
            } catch (t) {
              return it.error = t, it;
            }
          }
          function v(t, e, n, o) {
            try {
              t.call(e, n, o);
            } catch (t) {
              return t;
            }
          }
          function m(t, e, n) {
            V(function (t) {
              var o = !1,
                i = v(n, e, function (n) {
                  o || (o = !0, e !== n ? k(t, n) : S(t, n));
                }, function (e) {
                  o || (o = !0, C(t, e));
                }, "Settle: " + (t._label || " unknown promise"));
              !o && i && (o = !0, C(t, i));
            }, t);
          }
          function y(t, e) {
            e._state === nt ? S(t, e._result) : e._state === ot ? C(t, e._result) : b(e, void 0, function (e) {
              return k(t, e);
            }, function (e) {
              return C(t, e);
            });
          }
          function T(t, e, n) {
            e.constructor === t.constructor && n === u && e.constructor.resolve === l ? y(t, e) : n === it ? C(t, it.error) : void 0 === n ? S(t, e) : i(n) ? m(t, e, n) : S(t, e);
          }
          function k(e, n) {
            e === n ? C(e, d()) : t(n) ? T(e, n, f(n)) : S(e, n);
          }
          function w(t) {
            t._onerror && t._onerror(t._result), R(t);
          }
          function S(t, e) {
            t._state === et && (t._result = e, t._state = nt, 0 !== t._subscribers.length && V(R, t));
          }
          function C(t, e) {
            t._state === et && (t._state = ot, t._result = e, V(w, t));
          }
          function b(t, e, n, o) {
            var i = t._subscribers,
              r = i.length;
            t._onerror = null, i[r] = e, i[r + nt] = n, i[r + ot] = o, 0 === r && t._state && V(R, t);
          }
          function R(t) {
            var e = t._subscribers,
              n = t._state;
            if (0 !== e.length) {
              for (var o = void 0, i = void 0, r = t._result, s = 0; s < e.length; s += 3) o = e[s], i = e[s + n], o ? P(n, o, i, r) : i(r);
              t._subscribers.length = 0;
            }
          }
          function I() {
            this.error = null;
          }
          function E(t, e) {
            try {
              return t(e);
            } catch (t) {
              return rt.error = t, rt;
            }
          }
          function P(t, e, n, o) {
            var r = i(n),
              s = void 0,
              c = void 0,
              a = void 0,
              h = void 0;
            if (r) {
              if (s = E(n, o), s === rt ? (h = !0, c = s.error, s = null) : a = !0, e === s) return void C(e, g());
            } else s = o, a = !0;
            e._state !== et || (r && a ? k(e, s) : h ? C(e, c) : t === nt ? S(e, s) : t === ot && C(e, s));
          }
          function U(t, e) {
            try {
              e(function (e) {
                k(t, e);
              }, function (e) {
                C(t, e);
              });
            } catch (e) {
              C(t, e);
            }
          }
          function _() {
            return st++;
          }
          function O(t) {
            t[tt] = st++, t._state = void 0, t._result = void 0, t._subscribers = [];
          }
          function M(t, e) {
            this._instanceConstructor = t, this.promise = new t(p), this.promise[tt] || O(this.promise), F(e) ? (this._input = e, this.length = e.length, this._remaining = e.length, this._result = new Array(this.length), 0 === this.length ? S(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(), 0 === this._remaining && S(this.promise, this._result))) : C(this.promise, A());
          }
          function A() {
            return new Error("Array Methods must be provided an Array");
          }
          function x(t) {
            return new M(this, t).promise;
          }
          function D(t) {
            var e = this;
            return new e(F(t) ? function (n, o) {
              for (var i = t.length, r = 0; r < i; r++) e.resolve(t[r]).then(n, o);
            } : function (t, e) {
              return e(new TypeError("You must pass an array to race."));
            });
          }
          function L(t) {
            var e = this,
              n = new e(p);
            return C(n, t), n;
          }
          function N() {
            throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
          }
          function q() {
            throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
          }
          function j(t) {
            this[tt] = _(), this._result = this._state = void 0, this._subscribers = [], p !== t && ("function" != typeof t && N(), this instanceof j ? U(this, t) : q());
          }
          function H() {
            var t = void 0;
            if (void 0 !== o) t = o;else if ("undefined" != typeof self) t = self;else try {
              t = Function("return this")();
            } catch (t) {
              throw new Error("polyfill failed because global object is unavailable in this environment");
            }
            var e = t.Promise;
            if (e) {
              var n = null;
              try {
                n = Object.prototype.toString.call(e.resolve());
              } catch (t) {}
              if ("[object Promise]" === n && !e.cast) return;
            }
            t.Promise = j;
          }
          var B = void 0;
          B = Array.isArray ? Array.isArray : function (t) {
            return "[object Array]" === Object.prototype.toString.call(t);
          };
          var F = B,
            J = 0,
            X = void 0,
            $ = void 0,
            V = function (t, e) {
              Y[J] = t, Y[J + 1] = e, 2 === (J += 2) && ($ ? $(h) : Z());
            },
            G = "undefined" != typeof window ? window : void 0,
            K = G || {},
            W = K.MutationObserver || K.WebKitMutationObserver,
            z = "undefined" == typeof self && void 0 !== e && "[object process]" === {}.toString.call(e),
            Q = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel,
            Y = new Array(1e3),
            Z = void 0;
          Z = z ? function () {
            return function () {
              return e.nextTick(h);
            };
          }() : W ? function () {
            var t = 0,
              e = new W(h),
              n = document.createTextNode("");
            return e.observe(n, {
              characterData: !0
            }), function () {
              n.data = t = ++t % 2;
            };
          }() : Q ? function () {
            var t = new MessageChannel();
            return t.port1.onmessage = h, function () {
              return t.port2.postMessage(0);
            };
          }() : void 0 === G ? function () {
            try {
              var t = n(21);
              return X = t.runOnLoop || t.runOnContext, c();
            } catch (t) {
              return a();
            }
          }() : a();
          var tt = Math.random().toString(36).substring(16),
            et = void 0,
            nt = 1,
            ot = 2,
            it = new I(),
            rt = new I(),
            st = 0;
          return M.prototype._enumerate = function () {
            for (var t = this.length, e = this._input, n = 0; this._state === et && n < t; n++) this._eachEntry(e[n], n);
          }, M.prototype._eachEntry = function (t, e) {
            var n = this._instanceConstructor,
              o = n.resolve;
            if (o === l) {
              var i = f(t);
              if (i === u && t._state !== et) this._settledAt(t._state, e, t._result);else if ("function" != typeof i) this._remaining--, this._result[e] = t;else if (n === j) {
                var r = new n(p);
                T(r, t, i), this._willSettleAt(r, e);
              } else this._willSettleAt(new n(function (e) {
                return e(t);
              }), e);
            } else this._willSettleAt(o(t), e);
          }, M.prototype._settledAt = function (t, e, n) {
            var o = this.promise;
            o._state === et && (this._remaining--, t === ot ? C(o, n) : this._result[e] = n), 0 === this._remaining && S(o, this._result);
          }, M.prototype._willSettleAt = function (t, e) {
            var n = this;
            b(t, void 0, function (t) {
              return n._settledAt(nt, e, t);
            }, function (t) {
              return n._settledAt(ot, e, t);
            });
          }, j.all = x, j.race = D, j.resolve = l, j.reject = L, j._setScheduler = r, j._setAsap = s, j._asap = V, j.prototype = {
            constructor: j,
            then: u,
            catch: function (t) {
              return this.then(null, t);
            }
          }, j.polyfill = H, j.Promise = j, j;
        });
      }).call(e, n(13), n(4));
    }, function (t, e) {
      function n() {
        throw new Error("setTimeout has not been defined");
      }
      function o() {
        throw new Error("clearTimeout has not been defined");
      }
      function i(t) {
        if (u === setTimeout) return setTimeout(t, 0);
        if ((u === n || !u) && setTimeout) return u = setTimeout, setTimeout(t, 0);
        try {
          return u(t, 0);
        } catch (e) {
          try {
            return u.call(null, t, 0);
          } catch (e) {
            return u.call(this, t, 0);
          }
        }
      }
      function r(t) {
        if (l === clearTimeout) return clearTimeout(t);
        if ((l === o || !l) && clearTimeout) return l = clearTimeout, clearTimeout(t);
        try {
          return l(t);
        } catch (e) {
          try {
            return l.call(null, t);
          } catch (e) {
            return l.call(this, t);
          }
        }
      }
      function s() {
        f && d && (f = !1, d.length ? g = d.concat(g) : v = -1, g.length && c());
      }
      function c() {
        if (!f) {
          var t = i(s);
          f = !0;
          for (var e = g.length; e;) {
            for (d = g, g = []; ++v < e;) d && d[v].run();
            v = -1, e = g.length;
          }
          d = null, f = !1, r(t);
        }
      }
      function a(t, e) {
        this.fun = t, this.array = e;
      }
      function h() {}
      var u,
        l,
        p = t.exports = {};
      !function () {
        try {
          u = "function" == typeof setTimeout ? setTimeout : n;
        } catch (t) {
          u = n;
        }
        try {
          l = "function" == typeof clearTimeout ? clearTimeout : o;
        } catch (t) {
          l = o;
        }
      }();
      var d,
        g = [],
        f = !1,
        v = -1;
      p.nextTick = function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        g.push(new a(t, e)), 1 !== g.length || f || i(c);
      }, a.prototype.run = function () {
        this.fun.apply(null, this.array);
      }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = h, p.addListener = h, p.once = h, p.off = h, p.removeListener = h, p.removeAllListeners = h, p.emit = h, p.prependListener = h, p.prependOnceListener = h, p.listeners = function (t) {
        return [];
      }, p.binding = function (t) {
        throw new Error("process.binding is not supported");
      }, p.cwd = function () {
        return "/";
      }, p.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }, p.umask = function () {
        return 0;
      };
    }, function (t, e) {
      t.exports = function (t) {
        return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function () {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function () {
            return t.i;
          }
        }), t.webpackPolyfill = 1), t;
      };
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(3),
        i = n(1),
        r = n(0),
        s = function () {
          function t(t) {
            this.id = t, this.status = 200, this.headers = {}, this.body = "";
          }
          return t;
        }();
      e.ResponseData = s;
      var c;
      !function (t) {
        t.Connected = "trouter_js_client_connected", t.Disconnected = "trouter_js_client_disconnected", t.Error = "trouter_js_client_error", t.Progress = "trouter_js_client_progress", t.Response = "trouter_js_client_response", t.Request = "trouter_js_client_request", t.CheckConnection = "trouter_js_client_check_connection", t.Registration = "trouter_js_client_registration", t.Unregistration = "trouter_js_client_unregistration";
      }(c = e.ClientEventName || (e.ClientEventName = {}));
      var a = function () {
        function t(t, e, n, o, i) {
          this.stepName = t, this.operation = e, this.delta = n, this.ts = o, this.error = i;
        }
        return t;
      }();
      e.TrackerStep = a;
      var h = function () {
        function t() {}
        return t;
      }();
      e.Properties = h;
      var u = function () {
          function t() {
            this.numberOfPingReplies = 0, this.connectedTimestamp = 0, this.isNewUrl = !1, this.transportType = "", this.connectionNumber = 0;
          }
          return t;
        }(),
        l = function () {
          function t() {
            this.enabled = !1, this.numberOfStepsToMaintain = 40, this.logHealthCheckError = !1, this.sendProgressTimeoutSecs = 55, this.logSendPingError = !1, this.maxBackoffInMs = 12e4, this.trouter_js_client_connected = !1, this.trouter_js_client_disconnected = !1, this.trouter_js_client_error = !1, this.trouter_js_client_progress = !1, this.trouter_js_client_response = !1, this.trouter_js_client_request = !1, this.trouter_js_client_registration = !1, this.trouter_js_client_unregistration = !1, this.trouter_js_client_check_connection = !0;
          }
          return t;
        }(),
        p = function () {
          function t(t, e, n, i, s, c, a) {
            this.clientId = e, this.clientInfo = n, this.getServerState = i, this.endpointId = s, this.clientCorrelationID = c, this.environment = a, this.logger = new r.Logger("ConnectionTracker", t), this.clientCorrelationID = void 0 !== c ? c : "", this.steps = [], this.connectionAttempt = 0, this.totalStepCount = 0, this.beginTimestamp = new o.Timespan(), this.eventLogSettings = new l(), this.connectedInfo = new u();
          }
          return t.prototype.enable = function (t) {
            this.eventLogSettings.enabled = !0, this.eventLogger = t;
          }, t.prototype.disable = function () {
            this.eventLogSettings.enabled = !1;
          }, t.prototype.sendProgress = function (t) {
            this.steps.length > 0 && this.sendTelemetry(c.Progress, t, this.steps);
          }, t.prototype.cancelProgressTimer = function () {
            void 0 !== this.progressTimeout && (clearTimeout(this.progressTimeout), this.progressTimeout = void 0);
          }, t.prototype.resetProgressSendTimer = function () {
            var t = this;
            this.cancelProgressTimer(), void 0 !== this.eventLogSettings.sendProgressTimeoutSecs && this.eventLogSettings.sendProgressTimeoutSecs > 0 && (this.progressTimeout = setTimeout(function () {
              t.sendProgress({
                reason: "timeout",
                timeoutSecs: t.eventLogSettings.sendProgressTimeoutSecs
              });
            }, 1e3 * this.eventLogSettings.sendProgressTimeoutSecs));
          }, t.prototype.setConnectedInfo = function (t, e) {
            this.connectedInfo.numberOfPingReplies = 0, this.connectedInfo.connectedTimestamp = Date.now(), this.connectedInfo.isNewUrl = t, this.connectedInfo.transportType = e, ++this.connectedInfo.connectionNumber;
          }, t.prototype.clearConnectedInfo = function () {
            this.connectedInfo.numberOfPingReplies = 0, this.connectedInfo.connectedTimestamp = 0, this.connectedInfo.isNewUrl = !0, this.connectedInfo.transportType = "";
          }, t.prototype.copyProperties = function (t, e) {
            for (var n = 0, o = Object.keys(e); n < o.length; n++) {
              var i = o[n];
              e.hasOwnProperty(i) && void 0 !== e[i] && (t[i.replace(/-/g, "_")] = {
                value: e[i]
              });
            }
          }, t.prototype.increasePingResponseCount = function () {
            ++this.connectedInfo.numberOfPingReplies;
          }, t.prototype.sendTelemetry = function (t, e, n) {
            try {
              if (!0 === this.eventLogSettings.enabled && !0 === this.eventLogSettings[t] && void 0 !== this.eventLogger) {
                var r = this.getServerState(),
                  s = {
                    name: t,
                    properties: {
                      connectionAttempt: {
                        value: this.connectionAttempt
                      },
                      epid: {
                        value: this.endpointId
                      },
                      clientCorrelationID: {
                        value: this.clientCorrelationID
                      },
                      steps: {
                        value: o.toJson(n)
                      },
                      clientID: {
                        value: this.clientId
                      },
                      eventVersion: {
                        value: 3
                      },
                      environment: {
                        value: this.environment
                      },
                      cv: {
                        value: i.CLIENT_VERSION
                      },
                      ua: {
                        value: this.clientInfo.ua
                      },
                      connectionId: {
                        value: r.connectionId
                      },
                      connectedClientId: {
                        value: r.connectedClientId
                      },
                      domId: {
                        value: r.domId
                      },
                      url: {
                        value: r.unsecureUrl
                      },
                      surl: {
                        value: r.url
                      },
                      ttlInSecs: {
                        value: r.getRemainingTtlInSec()
                      },
                      numberOfPingReplies: {
                        value: this.connectedInfo.numberOfPingReplies
                      },
                      connectedTimestamp: {
                        value: this.connectedInfo.connectedTimestamp
                      },
                      isNewUrl: {
                        value: this.connectedInfo.isNewUrl
                      },
                      transportType: {
                        value: this.connectedInfo.transportType
                      },
                      connectionNumber: {
                        value: this.connectedInfo.connectionNumber
                      }
                    }
                  };
                this.copyProperties(s.properties, e), this.eventLogger.logEvent(s);
              }
            } catch (e) {
              this.logger.warn("error in sending event " + t + ": " + o.toJson(e));
            }
          }, t.prototype.createStep = function (t, e, n) {
            return new a(t, e, this.beginTimestamp.duration, Date.now(), n);
          }, t.prototype.addStep = function (t, e, n) {
            if (!1 !== this.eventLogSettings.enabled && (0 === this.steps.length && this.beginTimestamp.reset(), this.steps.push(this.createStep(t, e, n)), ++this.totalStepCount, void 0 !== this.eventLogSettings.numberOfStepsToMaintain && this.steps.length > this.eventLogSettings.numberOfStepsToMaintain)) {
              var o = this.steps.slice(0);
              this.steps.length = 0, this.sendTelemetry(c.Progress, {
                reason: "flush"
              }, o);
            }
          }, t.prototype.trackStart = function (t) {
            this.addStep(t, "start");
          }, t.prototype.trackEnd = function (t) {
            this.addStep(t, "end");
          }, t.prototype.trackError = function (t, e, n, o) {
            void 0 === n && (n = !0), "health" === t && !0 !== this.eventLogSettings.logHealthCheckError || "ping" === t && !1 === this.eventLogSettings.logSendPingError || (void 0 === o && (o = "error"), !0 === n && this.addStep(t, o, e), this.sendTelemetry(c.Error, {}, [this.createStep(t, o, e)]));
          }, t.prototype.trackProgress = function (t, e) {
            this.addStep(t, e);
          }, t.prototype.trackConnected = function (t, e) {
            this.setConnectedInfo(t, e);
            var n = this.steps.slice(0),
              o = this.totalStepCount,
              i = this.beginTimestamp.duration;
            this.steps.length = 0, this.totalStepCount = 0, this.sendTelemetry(c.Connected, {
              stepCount: n.length,
              totalStepCount: o,
              connectionEstablishmentMs_Total: i
            }, n), this.cancelProgressTimer();
          }, t.prototype.getSessionLength = function () {
            return Date.now() - this.connectedInfo.connectedTimestamp;
          }, t.prototype.trackDisconnected = function (t) {
            t.sessionLengthMS = this.getSessionLength(), this.sendTelemetry(c.Disconnected, t, []), this.resetProgressSendTimer();
          }, t.prototype.trackNewConnection = function () {
            ++this.connectionAttempt;
          }, t.prototype.trackRequest = function (t, e) {
            var n = {};
            void 0 !== e && (n.hasError = !0, n.error = e);
            try {
              if (t) {
                n.requestID = t.id, n.httpMethod = t.method, n.url = t.url, n.bodyLength = t.body.length, n.shortUrl = t.shortUrl, n.requestTimeStamp = t.startTS, n.correlationVector = t.correlationVector;
                for (var i = t.headers, r = 0, s = Object.keys(i); r < s.length; r++) {
                  var a = s[r];
                  i.hasOwnProperty(a) && (n[a] = i[a]);
                }
              }
            } catch (t) {
              n.hasError = !0, n.error = n.error + " error creating request context " + o.toJson(t);
            }
            this.sendTelemetry(c.Request, n, []);
          }, t.prototype.trackResponse = function (t, e, n, i) {
            var r = {};
            void 0 !== i && (r.hasError = !0, r.error = i);
            try {
              if (r.responseTimestamp = void 0 !== n ? n.sentTS : Date.now(), t) {
                r.requestID = t.id, r.httpMethod = t.method, r.shortUrl = t.shortUrl, r.correlationVector = t.correlationVector;
                for (var s = t.headers, a = 0, h = Object.keys(s); a < h.length; a++) {
                  var u = h[a];
                  s.hasOwnProperty(u) && (r[u] = s[u]);
                }
              }
              n && (r.latencyMS = e, r.responseCode = n.status, r.responseLength = n.body.length);
            } catch (t) {
              r.hasError = !0, r.error = r.error + " error creating response context " + o.toJson(t);
            }
            this.sendTelemetry(c.Response, r, []);
          }, t.prototype.sendResponseError = function (t, e, n) {
            this.trackResponse(e, void 0, n, t);
          }, t.prototype.close = function () {
            this.sendProgress({
              reason: "closed"
            }), this.steps.length = 0, this.cancelProgressTimer();
          }, t.prototype.mergeSettings = function (t) {
            if (t) {
              this.eventLogSettings.numberOfStepsToMaintain = Math.min(40, Math.max(10, void 0 !== t.numberOfStepsToMaintain ? t.numberOfStepsToMaintain : 0));
              var e = Math.min(3600, Math.max(55, void 0 !== t.sendProgressTimeoutSecs ? t.sendProgressTimeoutSecs : 0));
              this.eventLogSettings.logHealthCheckError = t.logHealthCheckError, this.eventLogSettings.logSendPingError = t.logSendPingError;
              for (var n = 0, o = Object.keys(c).map(function (t) {
                  return c[t];
                }); n < o.length; n++) {
                var i = o[n];
                t.hasOwnProperty(i) && void 0 !== t[i] && (this.eventLogSettings[i] = t[i]);
              }
              this.eventLogSettings.sendProgressTimeoutSecs !== e && (this.eventLogSettings.sendProgressTimeoutSecs = e, this.resetProgressSendTimer());
            }
          }, t;
        }();
      e.ConnectionTracker = p;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = function () {
        function t(t, e) {
          this.logger = t, this.maxBackoffInMs = e, this.backoffId = 0, this.backoffCount = 0;
        }
        return t.calculateNextBackoffMs = function (t, e) {
          var n = 1 + .4 * (Math.random() - .5),
            o = 1e3 * Math.pow(2, t) * n;
          return o = Math.round(o), Math.min(e, o);
        }, t.prototype.setMaxBackoffMs = function (t) {
          this.maxBackoffInMs = t;
        }, t.prototype.backoff = function (e, n) {
          var o = this;
          void 0 !== this.timerHandle && (this.logger.debug("Clearing current back off"), clearTimeout(this.timerHandle), this.timerHandle = void 0);
          var i = t.calculateNextBackoffMs(this.backoffCount, this.maxBackoffInMs);
          this.backoffId++, this.backoffCount++, this.logger.info("Backing off " + e + " for " + i + " milliseconds with ID " + this.backoffId), this.callback = function () {
            o.logger.info("Back off for " + e + " with ID " + o.backoffId + " complete, invoking handler"), o.timerHandle = void 0, o.callback = void 0, n();
          }, this.timerHandle = setTimeout(this.callback, i);
        }, t.prototype.reset = function () {
          void 0 !== this.timerHandle && (this.logger.debug("Resetting back off with ID " + this.backoffId), clearTimeout(this.timerHandle), this.timerHandle = void 0, this.callback = void 0), this.backoffCount = 0;
        }, t.prototype.expediteIfPending = function () {
          if (this.backoffCount = 0, void 0 !== this.timerHandle) {
            this.logger.debug("Expediting back off with ID " + this.backoffId), clearTimeout(this.timerHandle), this.timerHandle = void 0;
            var t = this.callback;
            this.callback = void 0, t && t();
          }
        }, t;
      }();
      e.ExponentialBackoff = o;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o,
        i = n(5),
        r = n(0);
      !function (t) {
        t[t.Initial = 0] = "Initial", t[t.RetrievingToken = 1] = "RetrievingToken", t[t.Allocating = 2] = "Allocating", t[t.Handshaking = 3] = "Handshaking", t[t.Connecting = 4] = "Connecting", t[t.Connected = 5] = "Connected", t[t.UnregisteringRetrievingToken = 6] = "UnregisteringRetrievingToken", t[t.Unregistering = 7] = "Unregistering", t[t.TerminalError = 8] = "TerminalError";
      }(o = e.State || (e.State = {}));
      var s;
      !function (t) {
        t[t.Initial = 0] = "Initial", t[t.RetrievingToken = 1] = "RetrievingToken", t[t.Registering = 2] = "Registering", t[t.Registered = 3] = "Registered", t[t.NotRegistered = 4] = "NotRegistered";
      }(s || (s = {}));
      var c = function () {
        function t(t, e, n) {
          this.worker = e, this.incallModeEnabled = n, this.state = o.Initial, this.autoReconnect = !0, this.logger = new r.Logger("ConnectionFsm", t), this.connectedSubstate = s.Initial;
        }
        return t.prototype.getState = function () {
          return this.state;
        }, t.prototype.isActive = function () {
          return this.state === o.Allocating || this.state === o.Connected || this.state === o.Handshaking || this.state === o.Connecting || this.state === o.RetrievingToken;
        }, t.prototype.start = function () {
          return this.state === o.Initial ? (this.setState(o.RetrievingToken), this.worker.getToken(!0, !1), !0) : (this.showIgnored("start"), !1);
        }, t.prototype.stop = function (t) {
          t && (this.connectedSubstate = s.Initial), this.worker.isIncallMode() && this.worker.exitIncallMode(), this.worker.resetTokenBackoff(), this.worker.resetRegisterBackoff(), this.worker.stopConnectionTimer(), this.worker.stopPingTimer(), this.worker.clearTimers(), this.worker.stopRegisterTimer(), this.state !== o.Connecting && this.state !== o.Handshaking && this.state !== o.Connected || (this.worker.stopSocketIo(), this.state === o.Connected && this.worker.sendDisconnectTelemetryEvent("connection stopped")), this.isRegistered() && this.state !== o.UnregisteringRetrievingToken && this.state !== o.Unregistering ? (this.setState(o.UnregisteringRetrievingToken), this.worker.getToken(!0, !1)) : (this.setState(o.Initial), this.worker.dispatchDisconnected());
        }, t.prototype.onTokenReceived = function (t) {
          this.state === o.RetrievingToken ? (this.setState(o.Allocating), this.worker.startConnectionTimer(), this.worker.sendAllocateRequest(t)) : this.state === o.Connected && this.connectedSubstate === s.RetrievingToken ? (this.connectedSubstate = s.Registering, this.worker.sendRegisterRequest()) : this.state === o.UnregisteringRetrievingToken ? (this.setState(o.Unregistering), this.worker.sendUnregisterRequest()) : this.showIgnored("onTokenReceived");
        }, t.prototype.checkConnection = function (t) {
          t && this.onPingInterval();
        }, t.prototype.onAllocationSucceed = function () {
          return this.state === o.Allocating ? (this.setState(o.Handshaking), this.connectedSubstate === s.Registered && this.worker.dispatchUnregistered(), this.connectedSubstate = s.Initial, this.worker.startSocketIo(), !0) : (this.showIgnored("onAllocationSucceed"), !1);
        }, t.prototype.onAllocationFailed = function (t) {
          this.state === o.Allocating ? (this.setState(o.RetrievingToken), this.worker.stopConnectionTimer(), this.worker.getToken(!t, !0)) : this.showIgnored("onAllocationFailed");
        }, t.prototype.onConnectingTimeout = function () {
          this.state === o.Allocating || this.state === o.Connecting || this.state === o.Handshaking ? (this.setState(o.RetrievingToken), this.worker.stopSocketIo(), this.worker.getToken(!0, !1)) : this.showIgnored("onConnectingTimeout");
        }, t.prototype.onConnecting = function () {
          this.state === o.Handshaking ? this.setState(o.Connecting) : this.showIgnored("onConnecting");
        }, t.prototype.onConnectingFailed = function () {
          this.state === o.Connecting ? this.onConnectingTimeout() : this.state === o.Handshaking ? (this.logger.error("Unexpected error in Socket.io - no valid transports"), this.onConnectingTimeout()) : this.showIgnored("onConnectingFailed");
        }, t.prototype.onSocketDisconnect = function (t) {
          this.state === o.Handshaking || this.state === o.Connected ? (this.worker.stopSocketIo(), this.worker.stopPingTimer(), this.worker.clearTimers(), this.worker.stopConnectionTimer(), this.state === o.Connected && this.worker.sendDisconnectTelemetryEvent(t), this.autoReconnect ? (this.setState(o.RetrievingToken), this.worker.resetRegisterBackoff(), this.worker.dispatchReconnecting(), this.worker.getToken(!0, !1)) : (this.logger.debug("Socket error/disconnect occurred and automatic reconnect is disabled. Connection will stop."), this.stop(!0))) : this.showIgnored("onSocketDisconnect");
        }, t.prototype.onTrouterConnected = function () {
          this.state === o.Connecting ? (this.setState(o.Connected), this.worker.resetTokenBackoff(), this.worker.stopConnectionTimer(), this.worker.sendUserActivityState(i.UserActivityEventReason.Connected, !0), this.worker.startPingTimer(), this.worker.dispatchConnected(), this.worker.shouldSkipRegistration() ? (this.connectedSubstate = s.NotRegistered, this.worker.dispatchRegistered()) : (this.connectedSubstate = s.RetrievingToken, this.worker.getToken(!0, !1))) : this.showIgnored("onTrouterConnected");
        }, t.prototype.onReconnectRequired = function (t, e) {
          this.worker.dispatchReconnectIsRequired(t, e);
        }, t.prototype.disableAutoReconnect = function () {
          this.autoReconnect = !1;
        }, t.prototype.onDownstreamRequest = function (t) {
          this.state === o.Connected ? (this.switchToIncallModeIfEnabled(), this.worker.dispatchDownstreamRequest(t)) : this.showIgnored("onDownstreamRequest");
        }, t.prototype.onTrouterMessageLost = function (t) {
          this.state === o.Connected ? this.worker.dispatchTrouterMessageLost(t) : this.showIgnored("onTrouterMessageLost");
        }, t.prototype.onPingInterval = function () {
          this.state === o.Connected ? this.worker.sendPingRequest() : this.showIgnored("onPingInterval");
        }, t.prototype.onPingResponseTimeout = function () {
          this.onMissedResponse("onPingResponseTimeout");
        }, t.prototype.onPingResponse = function () {
          this.state === o.Connected || this.showIgnored("onPingResponse");
        }, t.prototype.onRegistrationFailed = function (t) {
          this.state === o.Connected && this.connectedSubstate === s.Registering ? (this.connectedSubstate = s.RetrievingToken, this.worker.getToken(!t, !0)) : this.showIgnored("onRegistrationFailed");
        }, t.prototype.onRegistrationSucceed = function (t) {
          this.state === o.Connected ? (this.connectedSubstate === s.Registering && (this.connectedSubstate = s.Registered, this.worker.dispatchRegistered()), t && this.worker.startRegisterTimer()) : this.showIgnored("onRegistrationSucceed");
        }, t.prototype.onRegistrationTimeout = function () {
          this.state === o.Connected && this.connectedSubstate !== s.NotRegistered ? (this.connectedSubstate = s.RetrievingToken, this.worker.getToken(!0, !1)) : this.showIgnored("onRegistrationTimeout");
        }, t.prototype.onUnregistrationFailed = function (t) {
          this.state === o.Unregistering ? (this.setState(o.UnregisteringRetrievingToken), this.worker.getToken(!t, !t)) : this.showIgnored("onUnregistrationFailed");
        }, t.prototype.onUnregistrationSucceed = function () {
          this.state === o.Unregistering ? (this.setState(o.Initial), this.worker.dispatchUnregistered(), this.worker.dispatchDisconnected()) : this.showIgnored("onUnregistrationSucceed");
        }, t.prototype.onIncallModeTimer = function () {
          this.worker.exitIncallMode(), this.state === o.Connected ? (this.worker.stopPingTimer(), this.worker.startPingTimer()) : this.showIgnored("onIncallModeTimer");
        }, t.prototype.onSetUserActivityState = function (t, e) {
          e ? (this.logger.info("Changing user activity state to '" + t.toEventJSON() + "'"), this.worker.sendUserActivityState(i.UserActivityEventReason.Modified, this.state === o.Connected)) : this.logger.debug("Not changing the same user activity state '" + t.toEventJSON() + "'");
        }, t.prototype.onActivityStateResponseTimeout = function () {
          this.onMissedResponse("onActivityStateResponseTimeout");
        }, t.prototype.forceReconnect = function (t) {
          this.state === o.Connected && this.worker.sendDisconnectTelemetryEvent(t), this.setState(o.RetrievingToken), this.worker.resetTokenBackoff(), this.worker.stopConnectionTimer(), this.worker.resetRegisterBackoff(), this.worker.stopPingTimer(), this.worker.clearTimers(), this.worker.stopSocketIo(), this.worker.dispatchReconnecting(), this.worker.getToken(!0, !1);
        }, t.prototype.onTerminalError = function () {
          this.logger.error("Cannot proceed, reached terminal state. Switching from state '" + o[this.state] + "' to " + o[o.TerminalError]), this.setState(o.TerminalError);
        }, t.prototype.onMissedResponse = function (t) {
          this.state === o.Connected ? (this.setState(o.RetrievingToken), this.worker.resetRegisterBackoff(), this.worker.stopPingTimer(), this.worker.clearTimers(), this.worker.stopSocketIo(), this.worker.sendDisconnectTelemetryEvent(t), this.worker.dispatchReconnecting(), this.worker.getToken(!0, !1)) : this.showIgnored(t);
        }, t.prototype.showIgnored = function (t) {
          this.logger.debug("Ignoring event '" + t + "' in state '" + o[this.state] + "'");
        }, t.prototype.setState = function (t) {
          if (this.logger.info("Switching from state '" + o[this.state] + "' to state '" + o[t] + "'"), this.state === t) return void this.logger.error("Attempt to switching into the current state '" + o[t] + "'");
          this.state = t;
        }, t.prototype.isRegistered = function () {
          return this.connectedSubstate === s.Registered || this.connectedSubstate === s.Registering;
        }, t.prototype.switchToIncallModeIfEnabled = function () {
          this.incallModeEnabled && (this.worker.isIncallMode() || (this.worker.enterIncallMode(), this.worker.stopPingTimer(), this.worker.startPingTimer()), this.worker.restartIncallModeTimer());
        }, t;
      }();
      e.TrouterFsm = c;
    }, function (t, e, n) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = n(2),
        i = n(0),
        r = n(6),
        s = function () {
          function t(t, e) {
            this.worker = e, this.state = o.TrouterState.Unknown, this.logger = new i.Logger("ManagerFsm", t);
          }
          return t.prototype.start = function () {
            this.state === o.TrouterState.Unknown ? (this.setState(o.TrouterState.Disconnected), this.worker.forceStopLingeringConnection(), this.worker.startFirstConnection()) : this.showIgnored("start");
          }, t.prototype.stop = function (t) {
            this.state !== o.TrouterState.Unknown ? (this.setState(o.TrouterState.Unknown), this.worker.stopFirstConnection(!0 === t), this.worker.stopSecondConnection(!0 === t)) : this.showIgnored("stop");
          }, t.prototype.getState = function () {
            return this.state;
          }, t.prototype.onConnected = function (t) {
            this.state === o.TrouterState.Disconnected && t ? this.worker.doesSecondConnectionExist() ? this.setState(o.TrouterState.Switching) : (this.setState(o.TrouterState.Connected), this.worker.dispatchConnected()) : this.showIgnored("onConnected(" + t + ")");
          }, t.prototype.onRegistered = function (t) {
            this.state !== o.TrouterState.Disconnected || t ? this.state !== o.TrouterState.Switching || t || (this.setState(o.TrouterState.Connected), this.worker.switchConnections(), this.worker.stopSecondConnectionDelayed(), this.worker.dispatchConnected()) : (this.setState(o.TrouterState.Connected), this.worker.switchConnections(), this.worker.stopSecondConnection(!0), this.worker.dispatchConnected()), this.worker.dispatchRegistrationState(!0);
          }, t.prototype.onUnregistered = function (t) {
            t && this.worker.dispatchRegistrationState(!1);
          }, t.prototype.onReconnecting = function (t) {
            this.state === o.TrouterState.Connected && t ? (this.setState(o.TrouterState.Disconnected), this.worker.dispatchReconnecting()) : this.state === o.TrouterState.Switching && t ? (this.setState(o.TrouterState.Disconnected), this.worker.dispatchReconnecting()) : this.showIgnored("onReconnecting(" + t + ")");
          }, t.prototype.onReconnectionRequired = function (t, e, n) {
            this.state === o.TrouterState.Connected && t ? (this.setState(o.TrouterState.Switching), this.worker.startSecondConnection(e)) : this.state === o.TrouterState.Disconnected && t ? this.worker.startSecondConnection(e) : this.state === o.TrouterState.Switching && t && n === r.ReconnectReason.Configuration ? (this.logger.debug("onReconnectionRequired: switch requested while already in Switching state"), this.worker.stopSecondConnection(!0), this.worker.startSecondConnection(e)) : this.showIgnored("onReconnectionRequired(" + t + ")");
          }, t.prototype.onDisconnected = function (t) {
            this.state === o.TrouterState.Unknown && t ? this.worker.dispatchStopped() : this.showIgnored("onDisconnected(" + t + ")");
          }, t.prototype.showIgnored = function (t) {
            this.logger.info("Ignoring event '" + t + "' in state '" + o.TrouterState[this.state] + "'");
          }, t.prototype.setState = function (t) {
            if (this.logger.info("Switching from state '" + o.TrouterState[this.state] + "' to state '" + o.TrouterState[t] + "'"), this.state === t) return void this.logger.error("Attempt to switching into the current state '" + o.TrouterState[t] + "'");
            this.state = t;
          }, t;
        }();
      e.TrouterManagerFsm = s;
    }, function (t, e, n) {
      function o(t, e) {
        if (!e) return t;
        var n = a({}, t, {
          enabled: e.TelemetryEnabled
        });
        return void 0 !== e.ClientTelemetryEventEnabled && (n = a({}, n, e.ClientTelemetryEventEnabled)), n;
      }
      function i(t, e) {
        return {
          clientInfo: {
            ua: t.trouterSettings.productName,
            v: t.trouterSettings.version
          },
          ioOptions: {
            ackTimeoutMs: 5e3
          },
          clientCorrelationID: t.trouterSettings.sessionId,
          environment: t.trouterSettings.environment,
          telemetrySettings: o(t.telemetryConfig.settings, e),
          eventLogger: t.telemetryConfig.eventLogger,
          endpointId: t.trouterSettings.registrationId,
          trouterUrl: e && e.TrouterConnectionUrl || t.trouterSettings.trouterServiceUrl,
          registration: t.trouterSettings.registrarServiceUrl ? {
            registrarUrl: t.trouterSettings.registrarServiceUrl,
            registrationId: t.trouterSettings.registrationId || "",
            pnhAppId: t.trouterSettings.pnhAppId || "",
            platform: t.trouterSettings.platform || "",
            pnhTemplateKey: t.trouterSettings.pnhTemplate || "",
            platformUIVersion: t.trouterSettings.platformUIVersion || "",
            productContext: t.trouterSettings.pnhProductContext || void 0,
            context: t.trouterSettings.pnhContext || "",
            registrarTtlSec: (t.trouterSettings.maxRegistrationTimeInMs || 0) / 1e3
          } : void 0,
          timeoutOptions: a({
            connectionTimeoutMs: t.trouterSettings.trouterConnectTimeoutInMs || 3e4,
            fetchTimeoutMs: 1e4,
            pingTimeoutMs: 4e4,
            pongTimeoutMs: 5e3,
            maxBackoffMs: "TeamsCDL" === t.trouterSettings.productName ? 3e5 : 3e4,
            requestTimeoutMs: 5e3,
            userActivityResponseTimeoutMs: 1e4
          }, t.trouterSettings.timeoutOptions),
          incallTimeoutOptions: a({
            connectionTimeoutMs: 1e4,
            fetchTimeoutMs: 5e3,
            pingTimeoutMs: 5e3,
            pongTimeoutMs: 2e3,
            maxBackoffMs: "TeamsCDL" === t.trouterSettings.productName ? 3e5 : 1e4,
            requestTimeoutMs: 5e3,
            userActivityResponseTimeoutMs: 1e4
          }, t.trouterSettings.incallTimeoutOptions),
          incallModeTimeoutMs: t.trouterSettings.incallModeTimeoutMs || 0,
          lingeringConnectionDelayMs: 6e4,
          userActivitySecondResendDelayMs: t.trouterSettings.userActivitySecondResendDelayMs || 1e4,
          duplicateDisconnectThresholdMs: 1e4,
          connectionCache: t.connectionCache,
          registrationStateCallback: t.registrationStateCallbackForAcsDoNotUse,
          retryLimitOnTokenFetch: "TeamsCDL" === t.trouterSettings.productName ? 15 : t.trouterSettings.retryLimitOnTokenFetch
        };
      }
      function r(t) {
        return new y(t);
      }
      function s() {
        return l.CLIENT_VERSION;
      }
      function c(t, e) {
        var n = t.indexOf("://");
        if (n >= 0) {
          var o = t.indexOf("/", n + 3);
          if (o >= 0) return e + t.substr(o);
        }
        return "";
      }
      var a = this && this.__assign || Object.assign || function (t) {
          for (var e, n = 1, o = arguments.length; n < o; n++) {
            e = arguments[n];
            for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
          }
          return t;
        },
        h = this && this.__awaiter || function (t, e, n, o) {
          return new (n || (n = Promise))(function (i, r) {
            function s(t) {
              try {
                a(o.next(t));
              } catch (t) {
                r(t);
              }
            }
            function c(t) {
              try {
                a(o.throw(t));
              } catch (t) {
                r(t);
              }
            }
            function a(t) {
              t.done ? i(t.value) : new n(function (e) {
                e(t.value);
              }).then(s, c);
            }
            a((o = o.apply(t, e || [])).next());
          });
        },
        u = this && this.__generator || function (t, e) {
          function n(t) {
            return function (e) {
              return o([t, e]);
            };
          }
          function o(n) {
            if (i) throw new TypeError("Generator is already executing.");
            for (; a;) try {
              if (i = 1, r && (s = 2 & n[0] ? r.return : n[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, n[1])).done) return s;
              switch (r = 0, s && (n = [2 & n[0], s.value]), n[0]) {
                case 0:
                case 1:
                  s = n;
                  break;
                case 4:
                  return a.label++, {
                    value: n[1],
                    done: !1
                  };
                case 5:
                  a.label++, r = n[1], n = [0];
                  continue;
                case 7:
                  n = a.ops.pop(), a.trys.pop();
                  continue;
                default:
                  if (s = a.trys, !(s = s.length > 0 && s[s.length - 1]) && (6 === n[0] || 2 === n[0])) {
                    a = 0;
                    continue;
                  }
                  if (3 === n[0] && (!s || n[1] > s[0] && n[1] < s[3])) {
                    a.label = n[1];
                    break;
                  }
                  if (6 === n[0] && a.label < s[1]) {
                    a.label = s[1], s = n;
                    break;
                  }
                  if (s && a.label < s[2]) {
                    a.label = s[2], a.ops.push(n);
                    break;
                  }
                  s[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }
              n = e.call(t, a);
            } catch (t) {
              n = [6, t], r = 0;
            } finally {
              i = s = 0;
            }
            if (5 & n[0]) throw n[1];
            return {
              value: n[0] ? n[1] : void 0,
              done: !0
            };
          }
          var i,
            r,
            s,
            c,
            a = {
              label: 0,
              sent: function () {
                if (1 & s[0]) throw s[1];
                return s[1];
              },
              trys: [],
              ops: []
            };
          return c = {
            next: n(0),
            throw: n(1),
            return: n(2)
          }, "function" == typeof Symbol && (c[Symbol.iterator] = function () {
            return this;
          }), c;
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var l = n(1),
        p = n(2);
      e.TrouterState = p.TrouterState, e.UserActivityState = p.UserActivityState;
      var d = n(0),
        g = n(7),
        f = n(8),
        v = n(9),
        m = n(10),
        y = function () {
          function t(t) {
            this.logProvider = t, this.stateChangedListeners = [], this.logger = new d.Logger("Trouter", t), this.trouterUrlPromise = new m.TrouterUrlPromise(t), this.messageHandlers = new g.MessageHandlerRegistry(t), this.listeners = {}, this.connectionInfo = null, this.logger.info("Created TrouterService version " + l.CLIENT_VERSION);
          }
          return t.prototype.start = function (t) {
            if (this.logger.info("Start"), !t.trouterSettings.disableInternalSkypeTokenCache) {
              var e = t.skypeTokenProvider;
              t.skypeTokenProvider = f.addCacheAsBackupTo(e);
            }
            this.trouterCfg = t;
            var n = i(t, this.ecsCfg);
            void 0 === this.trouterServer && (this.trouterServer = new v.TrouterManager(this.logProvider, n, t.skypeTokenProvider, this)), this.trouterServer.start();
          }, t.prototype.stop = function (t) {
            this.logger.info("close connection"), this.trouterUrlPromise.rejectUrl(new Error("TrouterService is stopped")), void 0 !== this.trouterServer && this.trouterServer.stop(t);
          }, t.prototype.setEcsConfig = function (t) {
            return h(this, void 0, void 0, function () {
              var e = this;
              return u(this, function (n) {
                return [2, new Promise(function (n, o) {
                  if (e.ecsCfg = t.TrouterJScriptClient, e.logger.info("Setting ECS configuration to " + JSON.stringify(e.ecsCfg)), void 0 !== e.trouterServer && void 0 !== e.trouterCfg) {
                    var r = i(e.trouterCfg, e.ecsCfg);
                    e.trouterServer.configure(r);
                  }
                  n();
                })];
              });
            });
          }, t.prototype.checkConnection = function (t) {
            void 0 !== this.trouterServer && this.trouterServer.checkConnection(t || !1);
          }, t.prototype.resendRegistration = function () {
            return h(this, void 0, void 0, function () {
              return u(this, function (t) {
                if (!this.trouterServer) throw new Error("resendRegistration called too early");
                return [2, this.trouterServer.resendRegistration()];
              });
            });
          }, t.prototype.registerListener = function (t, e) {
            return "" === e || "/" !== e[0] || e.indexOf("?") >= 0 || e.indexOf("#") >= 0 ? (this.logger.error("Listener path '" + e + "' is not valid"), !1) : this.listeners[e] ? (this.logger.error("Another listener is already registered for path '" + e + "'"), !1) : (this.listeners[e] = t, this.logger.debug("Listener for path '" + e + "' registered"), this.connectionInfo && t.onTrouterConnected(this.connectionInfo.baseEndpointUrl + e, this.connectionInfo), !0);
          }, t.prototype.unregisterListener = function (t) {
            for (var e = [], n = 0, o = Object.keys(this.listeners); n < o.length; n++) {
              var i = o[n];
              this.listeners[i] === t && e.push(i);
            }
            if (0 === e.length) return !1;
            for (var r = 0, s = e; r < s.length; r++) {
              var i = s[r];
              delete this.listeners[i];
            }
            return this.logger.debug("Listener for path(s) '" + e.join("', '") + "' unregistered"), !0;
          }, t.prototype.onTrouterConnected = function (t, e) {
            this.logger.debug("Trouter is now connected");
            for (var n = 0, o = Object.keys(this.listeners); n < o.length; n++) {
              var i = o[n];
              try {
                this.listeners[i].onTrouterConnected(e.baseEndpointUrl + i, e);
              } catch (t) {
                this.logger.error("Listener '" + i + "' threw an exception from onTrouterConnected(): " + t);
              }
            }
            this.connectionInfo = e, this.trouterUrlPromise.resolveUrl(t), this.notifyStateChanged(p.TrouterState.Connected, {
              url: t,
              getRemainingTtlInSec: function () {
                return e.connectionTtlSec;
              }
            });
          }, t.prototype.onTrouterDisconnected = function () {
            this.logger.debug("Trouter is now disconnected"), this.connectionInfo = null;
            for (var t = 0, e = Object.keys(this.listeners); t < e.length; t++) {
              var n = e[t],
                o = this.listeners[n];
              if (o.onTrouterDisconnected) try {
                o.onTrouterDisconnected();
              } catch (t) {
                this.logger.error("Listener '" + n + "' threw an exception from onTrouterDisconnected(): " + t);
              }
            }
            this.notifyStateChanged(p.TrouterState.Disconnected);
          }, t.prototype.onTrouterRequest = function (t, e) {
            for (var n = "", o = 0, i = Object.keys(this.listeners); o < i.length; o++) {
              var r = i[o];
              t.path.substring(0, r.length) === r && r.length > n.length && (n = r);
            }
            if ("" === n) this.tryMessageHandlers(t, e) || (e.status = 404, e.headers = {
              "Trouter-Responder": "ClientLib"
            }, e.send());else try {
              this.listeners[n].onTrouterRequest(t, e);
            } catch (t) {
              this.logger.error("Listener '" + n + "' threw an exception from onTrouterRequest(): " + t), e.status = 500, e.headers = {
                "Trouter-Responder": "ClientLib"
              }, e.send();
            }
          }, t.prototype.onTrouterMessageLoss = function (t) {
            this.logger.info("onTrouterMessageLoss called with value " + t);
            for (var e = !0, n = 0, o = Object.keys(this.listeners); n < o.length; n++) {
              var i = o[n],
                r = this.listeners[i];
              if (r.onTrouterMessageLoss) try {
                e = r.onTrouterMessageLoss(t) && e, void 0 === e && (this.logger.error("Listener '" + i + "' did not response with boolean value onTrouterMessageLoss()"), e = !1);
              } catch (t) {
                this.logger.error("Listener '" + i + "' threw an exception from onTrouterMessageLoss(): " + t), e = !1;
              }
            }
            return e;
          }, t.prototype.onTrouterUserActivityStateAccepted = function (t) {
            this.logger.debug("onTrouterUserActivityStateAccepted cv: " + t);
            for (var e = 0, n = Object.keys(this.listeners); e < n.length; e++) {
              var o = n[e],
                i = this.listeners[o];
              if (i.onTrouterUserActivityStateAccepted) try {
                i.onTrouterUserActivityStateAccepted(t);
              } catch (t) {
                this.logger.error("Listener '" + o + "' threw an exception from onTrouterUserActivityStateAccepted(): " + t);
              }
            }
          }, t.prototype.setUserActivityState = function (t, e) {
            if (t !== p.UserActivityState.Active && t !== p.UserActivityState.Inactive) throw new Error("setUserActivityState called with unsupported value " + t);
            if (this.logger.info("setUserActivityState called with value " + p.UserActivityState[t]), !this.trouterServer || this.state() === p.TrouterState.Unknown) throw new Error("setUserActivityState called too early");
            this.trouterServer.setUserActivityState(t, e);
          }, t.prototype.state = function () {
            return void 0 !== this.trouterServer ? this.trouterServer.getState() : p.TrouterState.Unknown;
          }, t.prototype.getServerState = function () {
            if (void 0 !== this.trouterServer) return this.trouterServer.getServerState();
          }, t.prototype.getTrouterUrlAsync = function () {
            return void 0 !== this.trouterServer ? this.trouterUrlPromise.getPromise() : Promise.reject(new Error("TrouterService has not been started"));
          }, t.prototype.onStateChanged = function (t) {
            if (this.logger.info("onStateChanged called"), void 0 === t) this.stateChangedListeners = this.stateChangedListeners.filter(function (t) {
              return void 0 === t.wrappedCallback;
            });else {
              this.offStateChanged(t);
              var e = function (e, n) {
                t(e, n ? n.url : "");
              };
              e.wrappedCallback = t, this.stateChangedListeners.push(e);
            }
          }, t.prototype.offStateChanged = function (t) {
            this.logger.info("offStateChanged called");
            var e = this.stateChangedListeners.length;
            return this.stateChangedListeners = this.stateChangedListeners.filter(function (e) {
              return e.wrappedCallback !== t;
            }), e > this.stateChangedListeners.length;
          }, t.prototype.addCallback = function (t) {
            this.logger.info("addListener called"), -1 === this.stateChangedListeners.indexOf(t, 0) && void 0 !== t && this.stateChangedListeners.push(t);
          }, t.prototype.removeCallback = function (t) {
            this.logger.info("removeListener called");
            var e = this.stateChangedListeners.indexOf(t, 0);
            return e > -1 && (this.stateChangedListeners.splice(e, 1), !0);
          }, t.prototype.registerMessageHandler = function (t) {
            this.logger.info("registerMessageHandler is called"), this.messageHandlers.register(t);
          }, t.prototype.clearMessageHandlers = function () {
            this.logger.info("clearMessageHandlers is called"), this.messageHandlers.clear();
          }, t.prototype.notifyStateChanged = function (t, e) {
            var n = this;
            this.logger.info("notifyStateChanged called, will forward to " + this.stateChangedListeners.length + " listeners"), this.stateChangedListeners.forEach(function (o) {
              try {
                o(t, e);
              } catch (t) {
                n.logger.error("Error in callback " + t);
              }
            });
          }, t.prototype.tryMessageHandlers = function (t, e) {
            if (!this.messageHandlers.active()) return !1;
            var n,
              o = null;
            try {
              n = JSON.parse(t.body), o = n && (n.evt || n.eventId) || null;
            } catch (t) {}
            var i = {
                eventId: o,
                url: (this.connectionInfo ? this.connectionInfo.baseEndpointUrl : "") + t.path,
                body: n,
                rawBody: t.body,
                headers: t.headers
              },
              r = this.messageHandlers.handleMessage(i);
            return !!r.isHandled && (e.status = r.resultCode, r.responseHeaders && (e.headers = r.responseHeaders), r.responseBody && (e.body = r.responseBody), e.send(), !0);
          }, t;
        }();
      e.TrouterService = y, e.createTrouterService = r, e.getTrouterServiceVersion = s, e.replaceTrouterUrlBase = c;
    }, function (e, n) {
      e.exports = t;
    }, function (t, e) {}]);
  });
});
unwrapExports(tstrouter);
var constants = createCommonjsModule(function (module, exports) {
  // Copyright (c) Microsoft Corporation.
  // Licensed under the MIT license.
  exports.__esModule = true;
  exports.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES = 3;
  // GCC High gov cloud URLs
  exports.GCCHIGH_TROUTER_SERVICE_URL = "https://go.trouter.gov.teams.microsoft.us/v4/a";
  exports.GCCHIGH_REGISTRAR_SERVICE_URL = "https://registrar.gov.teams.microsoft.us/V3/registrations";
  // GCC gov cloud URLs
  exports.GCC_TROUTER_SERVICE_URL = "https://go.trouter.gcc.teams.microsoft.com/v4/a";
  // DoD gov cloud URLs
  exports.DOD_TROUTER_SERVICE_URL = "https://go.trouter.dod.teams.microsoft.us/v4/a";
  exports.DOD_REGISTRAR_SERVICE_URL = "https://registrar.dod.teams.microsoft.us/V3/registrations";
  // Int URLs
  exports.INT_TROUTER_SERVICE_URL = "https://go.trouter-int.skype.net/v4/a";
  exports.INT_REGISTRAR_SERVICE_URL = "https://edge.skype.net/registrar/testenv/v3/registrations";
  // Public URLs
  exports.PUBLIC_TROUTER_SERVICE_URL = "https://go.trouter.skype.com/v4/a";
  exports.PUBLIC_REGISTRAR_SERVICE_URL = "https://edge.skype.com/registrar/prod/v3/registrations";
  // Gov cloud types
  var CloudType;
  (function (CloudType) {
    CloudType["Public"] = "Public";
    CloudType["GccHigh"] = "GCC High";
    CloudType["Dod"] = "DoD";
  })(CloudType = exports.CloudType || (exports.CloudType = {}));
  var CloudPrefix;
  (function (CloudPrefix) {
    CloudPrefix["OrgId"] = "orgid";
    CloudPrefix["Acs"] = "acs";
    CloudPrefix["Spool"] = "spool";
    CloudPrefix["GccHigh"] = "gcch";
    CloudPrefix["GccHighAcs"] = "gcch-acs";
    CloudPrefix["Dod"] = "dod";
    CloudPrefix["DodAcs"] = "dod-acs";
  })(CloudPrefix = exports.CloudPrefix || (exports.CloudPrefix = {}));
});
unwrapExports(constants);
var constants_1 = constants.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES;
var constants_2 = constants.GCCHIGH_TROUTER_SERVICE_URL;
var constants_3 = constants.GCCHIGH_REGISTRAR_SERVICE_URL;
var constants_4 = constants.GCC_TROUTER_SERVICE_URL;
var constants_5 = constants.DOD_TROUTER_SERVICE_URL;
var constants_6 = constants.DOD_REGISTRAR_SERVICE_URL;
var constants_7 = constants.INT_TROUTER_SERVICE_URL;
var constants_8 = constants.INT_REGISTRAR_SERVICE_URL;
var constants_9 = constants.PUBLIC_TROUTER_SERVICE_URL;
var constants_10 = constants.PUBLIC_REGISTRAR_SERVICE_URL;
var constants_11 = constants.CloudType;
var constants_12 = constants.CloudPrefix;
var TrouterUtils = createCommonjsModule(function (module, exports) {
  // Copyright (c) Microsoft Corporation.
  // Licensed under the MIT license.
  var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __generator = commonjsGlobal && commonjsGlobal.__generator || function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: []
      },
      f,
      y,
      t,
      g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };
  exports.__esModule = true;
  var eventIds = new Map([["chatMessageReceived", 200], ["typingIndicatorReceived", 245], ["readReceiptReceived", 246], ["chatMessageEdited", 247], ["chatMessageDeleted", 248], ["chatThreadCreated", 257], ["chatThreadPropertiesUpdated", 258], ["chatThreadDeleted", 259], ["participantsAdded", 260], ["participantsRemoved", 261]]);
  var publicTeamsUserPrefix = "8:orgid:";
  var dodTeamsUserPrefix = "8:dod:";
  var gcchTeamsUserPrefix = "8:gcch:";
  var teamsVisitorUserPrefix = "8:teamsvisitor:";
  var phoneNumberPrefix = "4:";
  var acsUserPrefix = "8:acs:";
  var acsGcchUserPrefix = "8:gcch-acs:";
  var acsDodUserPrefix = "8:dod-acs:";
  var spoolUserPrefix = "8:spool:";
  exports.toMessageHandler = function (event, listener) {
    var eventId = eventIds.get(event);
    return {
      handleMessage: function (message) {
        var genericPayload = null;
        if (message === null || message === void 0 ? void 0 : message.rawBody) {
          genericPayload = JSON.parse(message.rawBody);
        }
        if (genericPayload === null || genericPayload.eventId !== eventId) {
          return undefined;
        }
        var eventPayload = toEventPayload(event, genericPayload);
        if (eventPayload === null) {
          return undefined;
        }
        listener(eventPayload);
        return {
          isHandled: true,
          resultCode: 200
        };
      }
    };
  };
  var toEventPayload = function (event, genericPayload) {
    if (event === "chatMessageReceived") {
      var payload = genericPayload;
      var eventPayload = {
        threadId: payload.groupId,
        sender: constructIdentifierKindFromMri(payload.senderId),
        senderDisplayName: payload.senderDisplayName,
        recipient: constructIdentifierKindFromMri(payload.recipientMri),
        id: payload.messageId,
        createdOn: new Date(payload.originalArrivalTime),
        version: payload.version,
        type: payload.messageType,
        message: payload.messageBody,
        metadata: parseMetadata(payload.acsChatMessageMetadata)
      };
      return eventPayload;
    }
    if (event === "chatMessageEdited") {
      var payload = genericPayload;
      var eventPayload = {
        threadId: payload.groupId,
        sender: constructIdentifierKindFromMri(payload.senderId),
        senderDisplayName: payload.senderDisplayName,
        recipient: constructIdentifierKindFromMri(payload.recipientMri),
        id: payload.messageId,
        createdOn: new Date(payload.originalArrivalTime),
        version: payload.version,
        message: payload.messageBody,
        editedOn: new Date(payload.edittime),
        type: payload.messageType,
        metadata: parseMetadata(payload.acsChatMessageMetadata)
      };
      return eventPayload;
    }
    if (event === "chatMessageDeleted") {
      var payload = genericPayload;
      var eventPayload = {
        threadId: payload.groupId,
        sender: constructIdentifierKindFromMri(payload.senderId),
        senderDisplayName: payload.senderDisplayName,
        recipient: constructIdentifierKindFromMri(payload.recipientMri),
        id: payload.messageId,
        createdOn: new Date(payload.originalArrivalTime),
        version: payload.version,
        deletedOn: new Date(payload.deletetime),
        type: payload.messageType
      };
      return eventPayload;
    }
    if (event === "typingIndicatorReceived") {
      var payload = genericPayload;
      var eventPayload = {
        threadId: payload.groupId,
        sender: constructIdentifierKindFromMri(payload.senderId),
        senderDisplayName: payload.senderDisplayName,
        recipient: constructIdentifierKindFromMri(payload.recipientMri),
        version: payload.version,
        receivedOn: new Date(payload.originalArrivalTime)
      };
      return eventPayload;
    }
    if (event === "readReceiptReceived") {
      var payload = genericPayload;
      var readReceiptMessageBody = JSON.parse(payload.messageBody);
      var consumptionHorizon = readReceiptMessageBody.consumptionhorizon.split(";");
      var eventPayload = {
        threadId: payload.groupId,
        sender: constructIdentifierKindFromMri(payload.senderId),
        senderDisplayName: "",
        recipient: constructIdentifierKindFromMri(payload.recipientMri),
        chatMessageId: payload.messageId,
        readOn: new Date(+consumptionHorizon[1])
      };
      return eventPayload;
    }
    if (event === "chatThreadCreated") {
      var payload = genericPayload;
      var createdByPayload = JSON.parse(unescape(payload.createdBy));
      var membersPayload = JSON.parse(unescape(payload.members));
      var propertiesPayload = JSON.parse(unescape(payload.properties));
      var createdBy = {
        id: constructIdentifierKindFromMri(createdByPayload.participantId),
        displayName: createdByPayload.displayName
      };
      var chatParticipants = membersPayload.map(function (m) {
        return {
          id: constructIdentifierKindFromMri(m.participantId),
          displayName: m.displayName
        };
      });
      var eventPayload = {
        threadId: payload.threadId,
        createdOn: new Date(payload.createTime),
        createdBy: createdBy,
        version: payload.version,
        participants: chatParticipants,
        properties: propertiesPayload
      };
      return eventPayload;
    }
    if (event === "chatThreadPropertiesUpdated") {
      var payload = genericPayload;
      var updatedByPayload = JSON.parse(unescape(payload.editedBy));
      var propertiesPayload = JSON.parse(unescape(payload.properties));
      var updatedBy = {
        id: constructIdentifierKindFromMri(updatedByPayload.participantId),
        displayName: updatedByPayload.displayName
      };
      var eventPayload = {
        threadId: payload.threadId,
        updatedOn: new Date(payload.editTime),
        updatedBy: updatedBy,
        version: payload.version,
        properties: propertiesPayload
      };
      return eventPayload;
    }
    if (event === "chatThreadDeleted") {
      var payload = genericPayload;
      var deletedByPayload = JSON.parse(unescape(payload.deletedBy));
      var deletedBy = {
        id: constructIdentifierKindFromMri(deletedByPayload.participantId),
        displayName: deletedByPayload.displayName
      };
      var eventPayload = {
        threadId: payload.threadId,
        deletedOn: new Date(payload.deleteTime),
        deletedBy: deletedBy,
        version: payload.version
      };
      return eventPayload;
    }
    if (event === "participantsAdded") {
      var payload = genericPayload;
      var addedByPayload = JSON.parse(unescape(payload.addedBy));
      var participantsAddedPayload = JSON.parse(unescape(payload.participantsAdded));
      var addedBy = {
        id: constructIdentifierKindFromMri(addedByPayload.participantId),
        displayName: addedByPayload.displayName
      };
      var chatParticipants = participantsAddedPayload.map(function (m) {
        return {
          id: constructIdentifierKindFromMri(m.participantId),
          displayName: m.displayName,
          shareHistoryTime: new Date(m.shareHistoryTime)
        };
      });
      var eventPayload = {
        threadId: payload.threadId,
        addedOn: new Date(payload.time),
        addedBy: addedBy,
        version: payload.version,
        participantsAdded: chatParticipants
      };
      return eventPayload;
    }
    if (event === "participantsRemoved") {
      var payload = genericPayload;
      var removedByPayload = JSON.parse(unescape(payload.removedBy));
      var participantsRemovedPayload = JSON.parse(unescape(payload.participantsRemoved));
      var removedBy = {
        id: constructIdentifierKindFromMri(removedByPayload.participantId),
        displayName: removedByPayload.displayName
      };
      var chatParticipants = participantsRemovedPayload.map(function (m) {
        return {
          id: constructIdentifierKindFromMri(m.participantId),
          displayName: m.displayName,
          shareHistoryTime: new Date(m.shareHistoryTime)
        };
      });
      var eventPayload = {
        threadId: payload.threadId,
        removedOn: new Date(payload.time),
        removedBy: removedBy,
        version: payload.version,
        participantsRemoved: chatParticipants
      };
      return eventPayload;
    }
    return null;
  };
  exports.toLogProvider = function (logger) {
    return {
      log: function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          message[_i] = arguments[_i];
        }
        return logger.info(message);
      },
      warn: function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          message[_i] = arguments[_i];
        }
        return logger.warning(message);
      },
      error: function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          message[_i] = arguments[_i];
        }
        return logger.error(message);
      },
      debug: function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          message[_i] = arguments[_i];
        }
        return logger.verbose(message);
      },
      info: function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          message[_i] = arguments[_i];
        }
        return logger.verbose(message);
      }
    };
  };
  exports.toTelemetrySender = function (logger) {
    return {
      logEvent: function (clientEvent) {
        return logger.info(clientEvent);
      }
    };
  };
  var constructIdentifierKindFromMri = function (mri) {
    if (mri.startsWith(publicTeamsUserPrefix)) {
      return {
        kind: "microsoftTeamsUser",
        rawId: mri,
        microsoftTeamsUserId: mri.substring(publicTeamsUserPrefix.length),
        isAnonymous: false,
        cloud: "public"
      };
    } else if (mri.startsWith(dodTeamsUserPrefix)) {
      return {
        kind: "microsoftTeamsUser",
        rawId: mri,
        microsoftTeamsUserId: mri.substring(dodTeamsUserPrefix.length),
        isAnonymous: false,
        cloud: "dod"
      };
    } else if (mri.startsWith(gcchTeamsUserPrefix)) {
      return {
        kind: "microsoftTeamsUser",
        rawId: mri,
        microsoftTeamsUserId: mri.substring(gcchTeamsUserPrefix.length),
        isAnonymous: false,
        cloud: "gcch"
      };
    } else if (mri.startsWith(teamsVisitorUserPrefix)) {
      return {
        kind: "microsoftTeamsUser",
        rawId: mri,
        microsoftTeamsUserId: mri.substring(teamsVisitorUserPrefix.length),
        isAnonymous: true
      };
    } else if (mri.startsWith(phoneNumberPrefix)) {
      return {
        kind: "phoneNumber",
        rawId: mri,
        phoneNumber: mri.substring(phoneNumberPrefix.length)
      };
    } else if (mri.startsWith(acsUserPrefix) || mri.startsWith(acsGcchUserPrefix) || mri.startsWith(acsDodUserPrefix) || mri.startsWith(spoolUserPrefix)) {
      return {
        kind: "communicationUser",
        communicationUserId: mri
      };
    } else {
      return {
        kind: "unknown",
        id: mri
      };
    }
  };
  var parseMetadata = function (metadata) {
    if (metadata === undefined || metadata === null || metadata === "" || metadata === "null") {
      return {};
    }
    return JSON.parse(metadata);
  };
  function base64decode(encodedString) {
    return !coreHttp.isNode ? atob(encodedString) : Buffer.from(encodedString, "base64").toString();
  }
  exports.base64decode = base64decode;
  var parseJWT = function (token) {
    var _a = token === null || token === void 0 ? void 0 : token.split("."),
      payload = _a[1];
    if (payload === undefined) {
      throw new Error("Invalid token");
    }
    payload = payload.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(base64decode(payload))));
  };
  exports.parseTokenCredential = function (credential) {
    return __awaiter(void 0, void 0, void 0, function () {
      var accessToken, jwtToken, parsedJwtToken, identityMri, acsResourceId, cloudType, resourceLocation;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, credential.getToken()];
          case 1:
            accessToken = _a.sent();
            jwtToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.token;
            parsedJwtToken = parseJWT(jwtToken);
            identityMri = parsedJwtToken.skypeid;
            acsResourceId = parsedJwtToken.resourceId;
            cloudType = getCloudTypeFromSkypeId(identityMri);
            resourceLocation = parsedJwtToken.resourceLocation || "";
            return [2 /*return*/, {
              jwtToken: jwtToken,
              acsResourceId: acsResourceId,
              identityMri: identityMri,
              cloudType: cloudType,
              resourceLocation: resourceLocation
            }];
        }
      });
    });
  };
  function getCloudTypeFromSkypeId(skypeId) {
    var cloudPrefix = skypeId.substring(0, skypeId.indexOf(":"));
    switch (cloudPrefix) {
      case constants.CloudPrefix.OrgId:
      case constants.CloudPrefix.Acs:
      case constants.CloudPrefix.Spool:
        {
          return constants.CloudType.Public;
        }
      case constants.CloudPrefix.GccHigh:
      case constants.CloudPrefix.GccHighAcs:
        {
          return constants.CloudType.GccHigh;
        }
      case constants.CloudPrefix.Dod:
      case constants.CloudPrefix.DodAcs:
        {
          return constants.CloudType.Dod;
        }
      default:
        {
          return constants.CloudType.Public;
        }
    }
  }
});
unwrapExports(TrouterUtils);
var TrouterUtils_1 = TrouterUtils.toMessageHandler;
var TrouterUtils_2 = TrouterUtils.toLogProvider;
var TrouterUtils_3 = TrouterUtils.toTelemetrySender;
var TrouterUtils_4 = TrouterUtils.base64decode;
var TrouterUtils_5 = TrouterUtils.parseTokenCredential;
var TrouterSettings = createCommonjsModule(function (module, exports) {
  var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __generator = commonjsGlobal && commonjsGlobal.__generator || function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: []
      },
      f,
      y,
      t,
      g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };
  exports.__esModule = true;
  var defaultSettings = {
    version: "1.0.0",
    registrationId: "",
    sessionId: "",
    pnhAppId: "AcsWeb",
    pnhTemplate: "AcsWeb_Chat_1.5",
    platform: "SPOOL",
    platformUIVersion: "0.0.0",
    environment: "",
    productName: "acs-chat-web",
    trouterServiceUrl: constants.PUBLIC_TROUTER_SERVICE_URL,
    registrarServiceUrl: constants.PUBLIC_REGISTRAR_SERVICE_URL,
    registrarRefreshTimeoutInMs: 350000,
    timeoutOptions: {
      connectionTimeoutMs: 20000,
      fetchTimeoutMs: 10000,
      pingTimeoutMs: 40000,
      pongTimeoutMs: 5000,
      maxBackoffMs: 50000,
      requestTimeoutMs: 5000
    },
    maxRegistrationTimeInMs: 7200000
  };
  var createDefaultSettings = function () {
    var settings = defaultSettings;
    settings.registrationId = coreHttp.generateUuid();
    settings.sessionId = coreHttp.generateUuid();
    return settings;
  };
  var createIntSettings = function () {
    var settings = createDefaultSettings();
    settings.pnhAppId = "cns-e2e-test";
    settings.pnhTemplate = "cns-e2e-test:1.5";
    settings.registrarServiceUrl = constants.INT_REGISTRAR_SERVICE_URL;
    settings.trouterServiceUrl = constants.INT_TROUTER_SERVICE_URL;
    return settings;
  };
  var createGccSettings = function () {
    var settings = createDefaultSettings();
    settings.registrarServiceUrl = constants.PUBLIC_REGISTRAR_SERVICE_URL;
    settings.trouterServiceUrl = constants.GCC_TROUTER_SERVICE_URL;
    return settings;
  };
  var createGcchSettings = function () {
    var settings = createDefaultSettings();
    settings.registrarServiceUrl = constants.GCCHIGH_REGISTRAR_SERVICE_URL;
    settings.trouterServiceUrl = constants.GCCHIGH_TROUTER_SERVICE_URL;
    return settings;
  };
  var createDodSettings = function () {
    var settings = createDefaultSettings();
    settings.registrarServiceUrl = constants.DOD_REGISTRAR_SERVICE_URL;
    settings.trouterServiceUrl = constants.DOD_TROUTER_SERVICE_URL;
    return settings;
  };
  exports.createSettings = function (credential, options) {
    return __awaiter(void 0, void 0, void 0, function () {
      var settings, parsedTokenCredential;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!((options === null || options === void 0 ? void 0 : options.environment) === "INT")) return [3 /*break*/, 1];
            settings = createIntSettings();
            return [3 /*break*/, 3];
          case 1:
            return [4 /*yield*/, TrouterUtils.parseTokenCredential(credential)];
          case 2:
            parsedTokenCredential = _b.sent();
            if (parsedTokenCredential.cloudType === constants.CloudType.GccHigh) {
              settings = createGcchSettings();
            } else if (parsedTokenCredential.cloudType === constants.CloudType.Dod) {
              settings = createDodSettings();
            } else if (parsedTokenCredential.resourceLocation === "usgcc") {
              settings = createGccSettings();
            } else {
              settings = createDefaultSettings();
            }
            _b.label = 3;
          case 3:
            settings.maxRegistrationTimeInMs = (_a = options === null || options === void 0 ? void 0 : options.registrationTimeInMs) !== null && _a !== void 0 ? _a : defaultSettings.maxRegistrationTimeInMs;
            return [2 /*return*/, settings];
        }
      });
    });
  };
  exports.defaultTelemetrySettings = {
    // TBD Can we hook up OpenTelemetry?
    enabled: false
  };
});
unwrapExports(TrouterSettings);
var TrouterSettings_1 = TrouterSettings.createSettings;
var TrouterSettings_2 = TrouterSettings.defaultTelemetrySettings;
var SignalingClient = createCommonjsModule(function (module, exports) {
  // Copyright (c) Microsoft Corporation.
  // Licensed under the MIT license.
  var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  var __generator = commonjsGlobal && commonjsGlobal.__generator || function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1];
          return t[1];
        },
        trys: [],
        ops: []
      },
      f,
      y,
      t,
      g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;
    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (_) try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  };
  exports.__esModule = true;
  var CommunicationSignalingClient = /** @class */function () {
    function CommunicationSignalingClient(credential, logger, options) {
      this.credential = credential;
      this.logger = logger;
      this.options = options;
      this.stateChangedListener = null;
      this.tokenFetchRetries = 0;
      this.trouter = tstrouter.createTrouterService(TrouterUtils.toLogProvider(logger));
    }
    CommunicationSignalingClient.prototype.start = function () {
      return __awaiter(this, void 0, void 0, function () {
        var _a, _b;
        var _this = this;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!(this.config === undefined)) return [3 /*break*/, 2];
              _a = this;
              _b = {};
              return [4 /*yield*/, TrouterSettings.createSettings(this.credential, this.options)];
            case 1:
              _a.config = (_b.trouterSettings = _c.sent(), _b.skypeTokenProvider = function (forceRefresh) {
                return __awaiter(_this, void 0, void 0, function () {
                  var _a, _b;
                  return __generator(this, function (_c) {
                    switch (_c.label) {
                      case 0:
                        if (!forceRefresh) return [3 /*break*/, 3];
                        this.tokenFetchRetries += 1;
                        if (!(this.tokenFetchRetries > constants.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.stop(true)];
                      case 1:
                        _c.sent();
                        throw new Error("Access token is expired and failed to fetch a valid one after " + constants.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES + " retries");
                      case 2:
                        return [3 /*break*/, 4];
                      case 3:
                        this.tokenFetchRetries = 0;
                        _c.label = 4;
                      case 4:
                        _b = (_a = Promise).resolve;
                        return [4 /*yield*/, this.credential.getToken()];
                      case 5:
                        return [2 /*return*/, _b.apply(_a, [_c.sent().token])];
                    }
                  });
                });
              }, _b.telemetryConfig = {
                eventLogger: TrouterUtils.toTelemetrySender(this.logger),
                settings: TrouterSettings.defaultTelemetrySettings
              }, _b);
              _c.label = 2;
            case 2:
              this.trouter.start(this.config);
              this.trouter.setUserActivityState(tstrouter.UserActivityState.Active);
              return [2 /*return*/];
          }
        });
      });
    };
    CommunicationSignalingClient.prototype.stop = function (isTokenExpired) {
      return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          this.trouter.offStateChanged(this.stateChangedListener);
          this.trouter.clearMessageHandlers();
          this.trouter.stop(isTokenExpired !== null && isTokenExpired !== void 0 ? isTokenExpired : this.tokenFetchRetries > constants.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES);
          return [2 /*return*/];
        });
      });
    };
    CommunicationSignalingClient.prototype.on = function (event, listener) {
      if (event === "connectionChanged") {
        this.trouter.offStateChanged(this.stateChangedListener);
        this.stateChangedListener = function (state, _url) {
          return listener(state);
        };
        this.trouter.onStateChanged(this.stateChangedListener);
        return;
      }
      this.trouter.registerMessageHandler(TrouterUtils.toMessageHandler(event, listener));
    };
    return CommunicationSignalingClient;
  }();
  exports.CommunicationSignalingClient = CommunicationSignalingClient;
});
unwrapExports(SignalingClient);
var SignalingClient_1 = SignalingClient.CommunicationSignalingClient;
var src = createCommonjsModule(function (module, exports) {
  // Copyright (c) Microsoft Corporation.
  // Licensed under the MIT license.
  function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
  exports.__esModule = true;
  __export(SignalingClient);
});
var index = unwrapExports(src);
module.exports = index;
